import VueI18n from 'vue-i18n'
import Vue from 'vue'

Vue.use(VueI18n);

const messages = {
  "en": {
    title: " | HKIASC",
    header: {
      // Header
      home: 'Home',
      about_us: 'About Us',
      facility: 'Facilities',
      event: 'Events',
      my_booking: 'My Bookings',
      my_account: 'My Account',
      more: 'More',
      help: 'Help',
      logout: 'Logout',
      login: 'Login',
      register: 'Registration',
      hi: 'Hi, {given_name} {surname}',
      pay: 'PAY',
      notifications: 'Notifications',
      exciting_activities: 'What\'s On',
      sitemap: 'Site Map',
      tnc: 'Terms of Use',
      privacy: 'Privacy Policy',
      allrights: '© Airport Authority Hong Kong. All Rights Reserved.',
      facilityOther: 'HKIA Staff Clubhouse',
      facilityHall: 'Multi-purpose Sports Hall',
      facilityRoom: 'Multi-function room',
      shopping_cart: 'Shopping Cart',
      pricing_info: 'HKIA Staff Clubhouse Facilities Price list',
    },
    notification: {
      no_notification: 'No Notification',
      see_all: 'See All',
    },
    home: {
      hkaa_link: 'https://www.hongkongairport.com/',
      description_title: 'ABOUT HKIA Staff Clubhouse',
      description_sub_title: 'HKIA Staff Clubhouse',
      description_content: 'HKIA Staff Clubhouse aims to provide a 5-star clubhouse with sophisticated services and amenities for relaxation and entertainment to airport community staff.',
      all_rights_reserved: 'Airport Authority Hong Kong. All Rights Reserved.',
      join_hkiarace_1: 'Join HKIARaCE!',
      join_hkiarace_2: 'It\'s free and easy',
      join_hkiarace_3: 'Not yet a Registered Staff of HKIARaCE?',
      join_hkiarace: 'JOIN NOW',

      hot_items: 'Hot Items',
      more_facility: 'More Facilities',
      upcoming_event: 'Recent Events',
      more_events: 'More Events',

      coming_soon: 'Coming Soon',
    },
    about_acc: {
      banner_title: 'About HKIA Staff Clubhouse',
      no_of_users: 'Number of registered staff',
      events_held: 'Events held',
      service_hour: 'Service hour',
      no_of_facility: 'Number of facility',
      total_space: 'Total space over',

      about_hkia_title: 'ABOUT HKIA Staff Clubhouse',
      about_hkia_sub_title: 'HKIA Staff Clubhouse',
      about_hkia_content: 'HKIA Staff Clubhouse aims to provide a 5-star clubhouse with sophisticated services and amenities for relaxation and entertainment to over 73,000 airport community staff',

      vision_title: '',
      vision_sub_title: 'VISION',
      vision_content: 'HKIA Staff Clubhouse provides a relaxing and vibrant venue which caters for the needs of airport community, from relaxation service to fitness training. The club facilities include gymnasium, multi-function room, karaoke room, quiet room, relaxation room, multi-purpose hall, BBQ area and roof garden. It is a great place to freshen up your mind.',

      map_and_location: 'CONTACT US',
      map_and_location_content: 'HKIA Staff Clubhouse, 10/F-11/F<br>Airport Community Building, 13 Cheong Tat Road,<br>Hong Kong International Airport, Lantau, Hong Kong <br><br>Service Hours:<br> 07:30 - 22:30<br><br>Contact no.:<br> 21881555 / 21881554<br><br>Email Address:<br> <a href="mailto:hkiasc@hkairport.com">hkiasc@hkairport.com</a>',

      learn_more: 'Learn more',
    },
    register: {
      login_info: 'Login Info',
      email: 'Email',
      invalid_email: 'Please enter valid email address',
      invalid_mobile: 'Please enter 8 digits only',
      mobile: 'Mobile No. (Optional)',
      password: 'Password',
      password_contain_eight_characters: 'Password contains more than 8 characters',
      password_contain_letters: 'Password contains at least one letter',
      password_contain_numbers: 'Password contains at least one number digit',
      password_contain_special_characters: 'Password contains at least one special characters (excluding space character)',
      confirm_password: 'Confirm Password',
      password_match: 'Password inputs match each other',

      basic_info: 'Basic Info',
      salutation: 'Salutation',
      surname_zh: 'Surname on Airport Staff Octopus Card (Chinese)',
      given_name_zh: 'Given Name on Airport Staff Octopus Card (Chinese)',
      surname_en: 'Surname on Airport Staff Octopus Card (English)',
      given_name_en: 'Given Name on Airport Staff Octopus Card (English)',
      only_input_english_characters: 'Please only enter english characters',
      company: 'Company',
      cannot_find_company: 'Could not find your company?',
      other_company_name: 'Company Name',

      sasv_info: 'Airport Staff Verification',
      octopus_no: 'Airport Staff Octopus Card Number with 8 - 10 digits',
      octopus_no_hint: '(including the digit in bracket)',
      incorrect_octopus_no: 'Please input Airport Staff Number Octopus Card with 8 - 10 digits',

      tnc: 'Please read and agree to our Terms and Conditions before register.',
      require_tnc: 'Please agree to terms and conditions',
      disagree: 'Disagree',
      agree: 'Agree',

      require_captcha: 'Please complete the verification',

      enter_required_field: 'Please enter this required field',
      select_company: 'Please select your company',
      required_fields: 'Required',

      name: 'Full English Name (on Octopus Card)',

      octopus_front: 'Airport Staff Octopus Card (Front)',
      octopus_back: 'Airport Staff Octopus Card (Back)',
      staff_card_front: 'Company Staff Card (Front)',
      staff_card_back: 'Company Staff Card (Back)',

      ocr_fail_msg: 'Octopus Validation Failed. Please Try Again',

      id_front: 'Company Staff Card / ARA Permit (Front)',
      id_back: 'Company Staff Card / ARA Permit (Back)',

      review: 'Review',

      registration_complete_details: 'Your registration has been approved. You will be able to access Landside Staff Cafeteria with your registered Octopus Card 30 minutes after registration approval.',

      complete: 'Registration Success',
      success_msg: 'You will be informed by email when the ID verification is completed.',
      back_to_home: 'Back To Home',

      canteen_upsell: 'You will be able to access Landside Staff Cafeteria with your registered Octopus Card 30 minutes after registration approval.',
      canteen_btn: 'Show Me',
      aca: 'Stay Tuned!',
      aca_subtitle: 'Download the HKG Community App now to get latest discounts.',
    },
    check_status: {
      title: 'Check Registration Status',

      octopus_no: 'Octopus Card No.',
      name: 'Name',
      status: 'Status',
      validated_at: 'Approved At',
      rejected_at: 'Rejected At',
      suspended_at: 'Suspended At',

      pending: 'Pending',
      pending_msg: 'Your registration has been submitted and being reviewed. Please come back and check your registration status after 1-2 working days',
      approved: 'Approved',
      approved_msg: 'Your registration has been approved. You will be able to access Landside Staff Cafeteria with your registered Octopus Card 30 minutes after registration approval.',
      rejected: 'Rejected',
      rejected_msg: 'Your registration has been rejected. Please try register again or contact us',
      suspended: 'Suspended',
      suspended_msg: 'Your registration has been suspended. Please try register again or contact us',
    },
    device_verification: {
      title: 'Second Factor Verification',
      content: 'An email with 6-digit verification code has been sent to your email address. Enter this code to continue.',
      second_factor_code: 'Verification Code',
      remember_device: 'Trust this browser for 180 days',
      incorrect_code: 'Incorrect Verification Code',
    },
    email_verify_init: {
      title: 'Email Verification',
      content: 'An email with verification link has been sent to your registered email address. Please complete the verification and login again.',
      resend: 'Resend Verification Email',
    },
    email_verify: {
      success_msg: 'Thank you for verifying your email address. You can now enjoy HKIARaCE events.',
      error_msg: 'Verification Link Expired',
    },
    login: {
      title: 'Login',
      username: 'Email',
      password: 'Password',
      forgot_password: 'Forgot Password?',
      locked_account_error: 'Account locked for one hour due to too many failed login attempts',
      disabled_account_error: 'Account has been disabled',
      wrong_password: 'Incorrect Email or Password',
    },
    remind_change_password: {
      modal_title: 'Reminder',
      modal_content: 'Your password has not been changed for over 90 days',
      skip: 'Skip',
      change_password: 'Change Password',
    },
    id_verification: {
      title: 'Identity Verification',
      // description: 'You will need to provide one of the following type of documents in order to become a registered user',
      description: 'Please provide the required identity to complete registration',
      verify_later: 'Verify Later',
      ara_permit_expiry_date: 'ARA Permit Expiry Date',
      suffix_number: 'Octopus Number',
      front: 'Front',
      back: 'Back',
      success_title: 'HKIARaCE Registration Success!',
      success_description: 'Congratulation! Your registration is approved. You can now enjoy our events and special offers',
      pending_title: 'HKIARaCE Registration Pending Approval',
      pending_description: 'Your registration is now pending for administrator\'s approval. You will be notified once it is completed.',
      duplicate_id_no: 'The ARA permit number has been used. Please contact us.',
    },
    reset_password_init: {
      modal_title: 'Reset Password',
      modal_content: 'Please check your email for password reset.',
    },
    reset_password: {
      title: 'Reset Password',
      email: 'Email',
      modal_title: 'Reset Password',
      modal_content: 'Password has been reset. Please login with new password',
      error_msg: 'Reset Link is no longer valid',
    },

    //Pre Reg
    pre_reg: {
      text_1: 'NEWLY BUILT<br>HKIA STAFF CLUBHOUSE',
      text_2: 'EXCLUSIVELY FOR<br> Airport Staff',
      text_3: 'Not yet a Registered Friends of HKIARaCE?',
      join_now: 'JOIN NOW',
      coming_soon: 'COMING SOON',
    },

    // HKIARaCE
    event: {
      date: 'Date',
      time: 'Time',
      location: 'Location',
      quota: 'Quota',
      languages: 'Languages',
      fee: 'Fee',
      remarks: 'Remarks',
      download_poster: 'Poster',
      download_attachment: 'Attachment',
      enroll: 'Enroll',
      free: 'Free',
      show_past_moment: 'Memorable Moments',
      prev_event: 'Previous Event',
      next_event: 'Next Event',
      session: 'Session',
      select_session: 'Select Session',
      series: 'Series',
      select_series: 'Select Series',
      meta: 'No. of People',
      email_not_validated: 'Email not validated',
      invalid_id: 'ID not validated',
      enroll_confirm_msg: 'Enroll Event?',
      input_fee_msg: 'Please select number of participant',
      input_session_msg: 'Please select your preferred session',
      no_event_msg: 'There are no any related events right now, please refer to ',
      no_event_msg_link: 'Memorable Moments',
      quota_template: '{quota} ppl',
    },
    enrollment_success: {
      title: '',
      description: 'Please check email for enrollment update',
    },
    my_account: {
      account_info: 'My Account',
      serial_no: 'HKIARaCE No.',
      name_en: 'Name (English)',
      name_zh: 'Name (Chinese)',
      mobile: 'Mobile',
      change_email: 'Change',
      change_email_title: 'Change Email',
      change_email_otp: 'OTP',
      change_email_send_otp: 'Send OTP',
      change_email_otp_resend_countdown: 'Resend in {second}s',
      click_to_show_qr_code: 'Click the image to show QR code',
      sasv_status: 'Airport Staff Verification',
      go_verify_sasv: 'Verify',


      past_event: 'My Events',


      change_password: 'Change Password',
      info_saved: 'Info Saved',
      incorrect_password: 'Incorrect Password',
      email_verified_at: 'Email Verification Status',
      verified_at_template: 'Verified at {date}',
      id_verified_at: 'Airport Octopus Card Verification Status',
      go_verify_id: 'Verify Octopus',
      enter_password: 'Enter Password to apply changes',
      membership_valid_until: 'Airport Octopus Card Verification Valid Until',
      card_title: 'HKIARaCE',
      member_name: '{given_name} {surname}',
      my_booking: 'My Bookings',
      octopus_mapped_at: 'Octopus Mapped At',
      octopus_id: 'Mapped Octopus ID',
      acc_membership_valid_until: 'Membership Valid Until',
      acc_membership_expired: 'Expired',
      acc_membership_price: 'Annual fee of HKIA Staff Clubhouse (HKD)',
      pay_acc_membership: 'Pay',
      confirm_pay_acc_membership: 'We will redirect you to payment page. You will be redirected back to our site after payment completion',
      coupon: 'Vouchers',
      map_octopus_error: 'You can only upgrade to Membership after you map your Octopus card',
      gym_subscriptions: 'Gym Pass',
      gym_subscriptions_checkin: 'Gym Pass Check-in',
      gym_bookings: 'Gym Reservation',
      points: 'Loyalty Points',
      point_balance: 'Loyalty Point Balance',
      point_transactions: 'Loyalty Point Transactions',
      topup: 'Top Up',
      package: 'Package Purchases',
      invoice: 'Invoices',

      octopus_privilege1: 'Landside Staff Cafeteria',
      octopus_privilege2: 'HKIARaCE friend',
      octopus_privilege3: 'HKIA Staff Clubhouse Member',

      receive_promotional_email: 'Receive Promotional Marketing Email',
    },
    change_password: {
      title: 'Change Password',
      current_password: 'Current Password',
      new_password: 'New Password',
      confirm_password: 'Confirm Password',
      success_msg: 'Password Successfully Changed. Please login with your new password.'
    },
    my_event_list: {
      title: 'My Event List',
      year: 'Year',
      category: 'Category',
      no_event: 'No Event',
      pay_amount: 'Amount',
      pay: 'Pay',
      start_survey: 'Start Survey',
      payment_success: 'Payment Success',
      payment_fail: 'Payment Unsuccessful',
      summary: 'Payment Summary',
      detail_title: 'Enrollment Detail',
    },
    past_event: {
      title: 'Memorable Moments',
    },
    promotion: {
      title: 'Shopping',
      banner: 'shopping & special offers',
      login: 'Create or login your account<br>to enjoy shopping experience',

      special_offer: 'Special Offers',
      shopping: 'Shopping',
    },
    survey: {
      error_msg: 'Link expired or something unexpected happened. Please try again later.',
      complete_msg: 'Survey completed. Thank you for your input.',
    },

    // ASC
    facility: {
      reserve_now: 'Reserve Now',
      bought_one_time_pass: 'ONE-TIME PASS PURCHASED',
      buy: 'Buy',
      view: 'View',
      available_choices: 'Available Choices: ',
      facility: 'Facility',
      date_and_time: 'Date & Time',
      max_session_length_msg: 'You can only book facility with a maximum length of {length} hours',
    },
    booking: {
      reference_number: 'Reference Number',
      reserved_at: 'Reserved At',
      select_venue: 'Select venue',
      facility: 'Facility',
      date: 'Date',
      time: 'Time',
      coupons: 'Vouchers',
      no_coupon: 'Do not use voucher',
      duplicate_coupon: 'Voucher already used on another booking',
      no_booking: 'No bookings',
      discount_code: 'Discount Code',
      clear_discount_code: 'Remove Discount Code?',
      fee: 'Reservation Total Price',
      need_bbq_option: 'Reserve BBQ Pack',
      second_contact_number: 'User Contact Number',
      status: 'Status',
      create_at: 'Reserved At',
      payment_method: 'Payment Method',
      pay_by_point: 'By Loyalty Points',
      no_need_to_pay: 'No Payment Needed',
      pay_with_octopus: 'Reservation by Octopus card can only be made at HKIA Clubhouse counter in person',
      invalid_second_contact_number: 'Please enter valid contact number',
      tnc_scroll_to_bottom: '',

      available: 'Available',
      unavailable: 'Unavailable',

      step_1: 'Pick a Date & Time',
      step_2: 'Booking Preview',
      step_3: 'Payment',
      quick_checkout: 'Quick Checkout',
      add_to_cart: 'Add to Cart',
      next_step: 'Next Step',

      select_additional_items: 'Add-on Items',

      acc_not_activated: 'You do not have a valid membership. Please scroll down and click "PAY" to activate',
      acc_suspended: 'Your membership is suspended due to multiple no-show in your bookings',
    },
    booking_preview: {
      preview_warning: 'Please finish transaction within the remaining time. Otherwise, selected facility will be released and user will be automatically logout by the system when time is expired.',
      booking_preview: 'Booking Preview',
      time_left: 'Time Left: ',
      accept_tnc1: 'I have read and accepted the',
      accept_tnc2: 'Terms & Conditions',
      redirect_warning: 'We will redirect you to payment page. You will be redirected back to our site after payment completion',
      order_expired_msg: 'Reservation has expired. Please book again.',
      add_payment_token: 'New Credit Card',
      checkout: 'Checkout',
    },
    booking_confirm: {
      date: 'Date',
      time: 'Period',
      item: 'Facility',
      price: 'Charge',
      additional_items: 'Add-ons',

      confirm_msg: 'Your booking has been confirmed',
      summary: 'Booking Summary',
    },
    booking_failure: {
      failure_msg: 'Payment Process was unsuccessful. Please try again',
      request_ref_no: 'Reference Number',
    },
    booking_detail: {
      title: 'Booking Details',
      cancel_booking: 'Cancel Booking',
      refund_booking: 'Refund Booking',
      cancel_booking_confirm_msg: 'Confirm Cancel Booking？',
    },
    coupon: {
      create_at: 'Issue Date',
      amount: 'Voucher Value',
      facility: 'Original Booking',
      item_type: 'Facility Type',
      valid_until: 'Valid Until',
      used_at: 'Used At',
      no_coupon: 'No Voucher',

      redeem_title: 'Redeem Voucher',
      redeem_code: 'Enter Redeem Code',
      redeem_success_msg: 'Redeem Successful',
    },
    gym_booking: {
      status: 'Gym Room Status',
      availability: 'Reservation Availability',
      available: 'Available',
      almost_full: 'Almost full',
      full: 'Full',
      booked_already: 'Booked',
      reserve: 'Reserve',
      reserve_title: 'Confirm',
      reserve_msg: 'Are you sure to submit your reservation?',
      success_title: 'SUCCESSFULLY RESERVATION',

      date: 'Booking Date',
      reference_number: 'Ref. No.',
      account: 'User',
      checkin_time: 'Checked In',
      booking_status: 'Status',

      cancel_confirm_msg: 'Confirm Cancel Gym Reservation?',
      cancel_success_msg: 'Gym Reservation Successfully Cancelled',
    },
    gym_subscription: {
      name: 'Gymnasium',
      title: 'Gym Pass',
      // question_consent: 'Do you understand how to use these equipments?',
      // consent: 'I understand how to use all these equipments',
      question_consent: 'I understand the guidelines of using Gymnasium.',
      consent: 'I understand the guidelines of using Gymnasium.',
      reference_number: 'Ref. No',
      type: 'Pass',
      status: 'Status',
      valid_until: 'Valid Until',
      account: 'User',
      checkin_time: 'Check In',
      checkout_time: 'Check Out',
      purchase_preview: 'Gym Pass Summary',
      confirm_msg: 'You have successfully purchased a Gym Pass',
      confirm_day_pass_msg: 'Please check the Gym’s availability before buying the one-time Gym pass',
    },
    point_transaction: {
      create_at: 'Date',
      type: 'Transaction Type',
      amount: 'Amount',
      top_up_title: 'Top Up Loyalty Points',
    },
    package: {
      detail_title: 'Package Purchase Detail',
      preview: 'Preview',
      create_at: 'Purchase Date',
      name: 'Package Name',
      description: 'Description',
      content: 'Package Content',
      price: 'Price',
      no_package: 'No Purchase Record',

      order_expired_msg: 'Purchase has expired. Please try again.',
    },
    invoice: {
      download_pdf: 'Download Invoice PDF',
      download_receipt: 'Download Receipt PDF',
      pay: 'Pay',
      pay_title: 'Invoice Payment',
      pay_success_title: 'Payment Successful',
      summary: 'Invoice Summary',
      payment_reference_no: 'Payment Reference No.',
      upload_success: 'Upload Successful',
    },

    // Admin
    admin: {
      sasv: 'SASV',
      member: 'Users',
      operator: 'Operators',
      hkiarace: 'HKIARaCE',
      acc_booking: 'Clubhouse',
      settings: 'Settings',
    },
    admin_login: {
      title: 'Administrator Login',
      username: 'Username',
    },

    admin_sasv: {
      title: 'SASV',
      edit_title: 'SASV Details',
      duplicate_title: 'Duplicated Names',
      validate_title: 'Validate SASV',

      update_at: 'Last Update',
      octopus_no: 'Octopus Card No.',
      name: 'Full Name',
      surname: 'Surname',
      given_name: 'Given Name',
      id_type: 'ID Type',
      id: 'Identifications',
      company: 'Company',
      other_company_name: 'Other Company Name',
      create_new_company: 'Add New Company',
      new_company_name_en: 'Company Name (English)',
      new_company_name_zh: 'Company Name (Chinese)',
      validated_at: 'Validated At',
      rejected_at: 'Rejected At',
      reject_reason: 'Reject Reason',
      status: 'Status',

      octopus_front: 'Airport Octopus Card / Personal Octopus Card (Front)',
      octopus_back: 'Airport Octopus Card / Personal Octopus Card (Back)',
      staff_card_front: 'Company Staff Card  (Front)',
      staff_card_back: 'Company Staff Card (Back)',

      accept: 'Accept',
      confirm_accept_msg: 'Accept SASV Registration?',
      reject: 'Reject',
      confirm_reject_msg: 'Reject SASV Registration?',
      suspend: 'Suspend',
      suspend_confirm_msg: 'Suspend SASV?',
      unsuspend: 'Un-Suspend',
      unsuspend_confirm_msg: 'Un-Suspend SASV?',

      mass_suspend_title: 'Mass Suspend',
      mass_suspend_csv: 'Upload CSV',

      email_templates: 'Email Templates',

      source: 'Registration Source',
    },

    admin_user: {
      title: 'Users',
      add_user: 'Add User',
      user_detail: 'User Detail',
      id_front: 'ID Front',
      id_back: 'ID Back',
      jwt: 'HKIARaCE Card QR Code',
      serial_no: 'HKIARaCE Card No.',
      name_en: 'Name (English)',
      name_zh: 'Name (Chinese)',
      sasv_name: 'Name on Airport Octopus Card',
      company: 'Company',
      email: 'Email',
      id_type: 'ID Type',
      id_no: 'Octopus Card No.',
      id_expiry_date: 'ID Expiry Date',
      accept: 'Accept',
      accept_with_gift: 'Accept (With Welcome Gift)',
      accept_without_gift: 'Accept (Without Welcome Gift)',
      reject: 'Reject',
      email_verified_at: 'Email Verified At',
      id_verified_at: 'ID Verified At',
      last_login: 'Last Login',
      locked_until: 'Account Locked',
      id_verification_status: 'ID Verification Status',
      sasv_not_submitted: 'Pending User SASV Submission',
      acc_suspend_until: 'Membership Suspend Until',
      welcome_gift_redeemed: 'Welcome Gift Redeemed',
      is_trial_user: 'Trial User',
      remarks: 'Remarks',

      require_email_verification: 'Require Email Verification',
      require_id_verification: 'Require ID Verification',

      validate_id_title: 'ID Verification',

      confirm_accept_msg: 'Confirm ACCEPT ID?',
      confirm_reject_msg: 'Confirm REJECT ID?',
      confirm_unlock_msg: 'Confirm UNLOCK Account?',
      confirm_enable_msg: 'Confirm ENABLE Account?',
      confirm_disable_msg: 'Confirm DISABLE Account?',
      confirm_remove_suspension_msg: 'Confirm Remove Suspension?',

      add_point_title: 'Add Loyalty Point',
      add_point_success_msg: 'Loyalty Point Successfully Added',
      add_gym_pass_title: 'Add Gym Pass',
      add_gym_pass_success_msg: 'Gym Pass Successfully Added',

      enrollment_history: 'Enrollment History',
      attendance_history: 'Attendance',
      booking_history: 'Booking History',
      payment_history: 'Payment History',
      coupon: 'Vouchers',

      export_user: 'Export',
    },

    admin_operator: {
      title: 'Admins',
      add_operator: 'Add Admin',
      operator_detail: 'Admin Details',
      email: 'Email',
      name_en: 'Name (English)',
      name_zh: 'Name (Chinese)',
      disabled: 'Disabled',
      locked_until: 'Account Locked',
      managed_events: 'Managed Events',
      user_type: 'User Type',
      permissions: 'Permissions',
      permission_pre_sets: 'Permission Pre-sets',
      permission_pre_set_hkiarace_admin: 'HKIARaCE Admin',
      permission_pre_set_acc_admin: 'Clubhouse Admin',
      permission_pre_set_helper: 'Event Helper',
    },

    admin_hkiarace: {
      company: 'Company',
      add_company: 'Add Company',
      user: 'User',
      operator: 'Admin',
      event_category: 'Event Category',
      event: 'Event',
      promotion: 'Special Offers',
      corporate_vendor: 'Corporate Vendors',
      email_template: 'Email Template',
      home_page: 'Home Page',
      check_in: 'Check In',
      report: 'Reports',
    },
    admin_company: {
      add_company: 'Add Company',
      edit_company: 'Edit Company',
      name_en: 'Company Name (English)',
      name_zh: 'Company Name (Chinese)',
      disabled: 'Disabled',
    },
    admin_event_category: {
      title: 'Event Category',
      add_category: 'Add Event Category',
      name_en: 'Name (English)',
      name_zh: 'Name (Chinese)',
      color: 'Color',
      layout_style: 'Layout Style',
      layout_style_list: 'List',
      layout_style_grid: 'Carousel',
      confirm_delete_category: 'Confirm Delete Event Category?',
    },
    admin_event: {
      add_title: 'New Event',
      edit_title: 'Event Detail',
      name_en: 'Name (English)',
      name_zh: 'Name (Chinese)',
      order_no: 'Ordering No.',
      signup_mode: 'Event Type',
      date: 'Event Date',
      time: 'Event Time',
      start_time: 'Start Time',
      end_time: 'End Time',
      fee: 'Fee',
      fixed_fee: 'Fixed Fee',
      fee_with_tiers: 'With Tiers',
      fee_tier: 'Tier',
      fee_tier_en: 'Tier (English)',
      fee_tier_zh: 'Tier (Chinese)',
      fee_tier_max: 'Maximum',
      add_fee_tier: 'Add Tier',
      quota: 'Quota',
      location_en: 'Location (English)',
      location_zh: 'Location (Chinese)',
      languages: 'Languages',
      remarks_en: 'Remarks (English)',
      remarks_zh: 'Remarks (Chinese)',
      visible_from: 'Publish At',
      signup_until: 'Enrollment End',
      visible_until: 'Published Until',
      visible_forever: 'Forever',
      banner: 'Banner',
      description_en: 'Banner Description (English)',
      description_zh: 'Banner Description (Chinese)',
      poster: 'Poster',
      attachment: 'Attachment',
      images: 'Images',
      category: 'Category',
      survey: 'Survey',
      no_session_msg: 'You have not setup sessions for this event',
      confirm_no_session_msg: 'You have not setup sessions for this event. Are you sure you want to set the publish date?',

      invalid_form_msg: 'Invalid / Missing Input, Please check and try again',
      save_success_msg: 'Event Saved',
    },
    admin_series: {
      title: 'Series',
      add_title: 'New Series',
      detail_title: 'Series Detail',
      sessions: 'Including Sessions',
      no_session_msg: 'You must select at least one session',
    },
    admin_event_survey: {
      survey_enabled: 'Survey Shown',
      title_en: 'Survey Title（English）',
      title_zh: 'Survey Title（Chinese）',
      description_en: 'Survey Description（English）',
      description_zh: 'Survey Description（Chinese）',
      questions: 'Questions',
      add_single_line_question: 'Add Single Line Question',
      add_freetext_question: 'Add Free Text Question',
      add_rating_question: 'Add Rating Question',
      clone_question: 'Clone Question',
      delete_question: 'Delete Question',
      question_type: 'Question Type',
      question_title_en: 'Question (English)',
      question_title_zh: 'Question (Chinese)',
      question_max_label_en: 'Label for 5（English）',
      question_max_label_zh: 'Label for 5（Chinese）',
      question_min_label_en: 'Label for 1（English）',
      question_min_label_zh: 'Label for 1（Chinese）',
      question_required: 'Required',
      user_input: 'Answer',
      freetext: 'Free Text',
      rating: 'Rating',
      export_data: 'Export',
      save_success_msg: 'Survey saved',
    },
    admin_session: {
      title: 'Session',
      add_title: 'Add Session',
      edit_title: 'Session Detail',
      name_en: 'Name (English)',
      name_zh: 'Name (Chinese)',
      time: 'Session Time',
      start: 'Session Start',
      end: 'Session End',
      quota: 'Quota',
      delete_msg: 'Confirm Delete Session？',
    },
    admin_enrollment: {
      enrolled_at: 'Enrolled At',
      account: 'User',
      company: 'Company',
      last_enrollment: 'Last Enrollment',
      pending: 'Pending',
      accept: 'Accept',
      reject: 'Reject',
      accepted: 'Accepted',
      rejected: 'Rejected',
      event: 'Event',
      session: 'Session',
      series: 'Series',
      meta: 'Enrollment Detail',
      status: 'Status',
      email_status: 'Email Status',
      send_email: 'Send Email',
      select_template: 'Select Template',
      send: 'Send',
    },
    admin_participant: {
      title: 'Participant',
      select_template: 'Select Template',
      send_email: 'Send Event Invitation',
      send_survey_email: 'Send Survey Email',
      send: 'Send',
      event: 'Event',
      session: 'Session',
      account: 'User',
      company: 'Company',
      mark_paid: 'Paid',
      checkin_time: 'Checked In At',
      manual_check_in: 'Manual Check In',
      mark_paid_confirm_msg: 'Confirm mark participant paid?',
      mark_paid_success_msg: 'Marked Paid',
      unmark_paid_confirm_msg: 'Confirm unmark participant paid?',
      unmark_paid_success_msg: 'Unmarked Paid',
      refund_success_msg: 'Refund Successfully',
      check_in_confirm_msg: 'Confirm manual check in?',
      check_in_success_msg: 'Manual Check In Success',
      cancel_check_in: 'Cancel Check In',
      cancel_check_in_confirm_msg: 'Confirm cancel check in?',
      cancel_check_in_success_msg: 'Check In Cancelled Successfully',

      normal_email: 'Normal Email',
      confirmation_email: 'Normal Email',
      survey_email: 'Normal Email',
    },
    admin_payment: {
      title: 'Payment',
      account: 'User',
      create_at: 'Order Created At',
      payment_type: 'Payment Type',
      payment_method: 'Payment Method',
      ref_no: 'Ref No.',
      card_no: 'Card No.',
      status: 'Status',
      total: 'Amount',

      refunded: 'Refunded',
    },
    admin_memorable_moment: {
      memorable_moment_enabled: 'Show in Memorable Moment',
      enable: 'Enable',
      disable: 'Disable',
      enabled: 'Enabled',
      disabled: 'Disabled',
      revert: 'Revert',
      cover: 'Cover Photo',
      add_photo: 'Add Photo',
      photo: 'Photo',
      reorder: 'Re-order',
    },
    admin_promotion: {
      title: 'Special Offers',
      add_title: 'Add Special Offer',
      edit_title: 'Special Offer Details',
      name: 'Name',
      from_time: 'Display From',
      to_time: 'Display Until',
      icon: 'Icon',
      content: 'Content',
      publish_promotion: 'Publish Special Offer',
      confirm_publish_msg: 'Confirm sending special offer email to ALL users?',
    },
    admin_corporate_vendor: {
      title: 'Corporate Vendor',
      add_title: 'Add Corporate Vendor',
      edit_title: 'Corporate Vendor Details',
      name_en: 'Name (English)',
      name_zh: 'Name (Chinese)',
      from_time: 'Display From',
      to_time: 'Display Until',
      icon_en: 'Icon (English)',
      icon_zh: 'Icon (Chinese)',
      url_en: 'Redirect URL (English)',
      url_zh: 'Redirect URL (Chinese)',
      popup_enabled: 'Enable Popup',
      content_en: 'Popup Content (English)',
      content_zh: 'Popup Content (Chinese)',
    },
    admin_notification_template: {
      edit_title: 'Edit Email Template',

      type: 'Email Type',
      name: 'Template Name',
      email_enabled: 'Enable Email',
      email_subject: 'Email Subject',
      email_content: 'Email Content',
      push_notification_enabled: 'Enable Notification',
      push_notification_content: 'Notification Content',
      test_email: 'Test Email',
      recipient: 'Recipient',
      send_email: 'Send',
      new_template: 'New Template',
      delete_template: 'DELETE TEMPLATE',
      confirm_send_email: 'Confirm Send Email?',
      email_sent: 'Email Sent',
    },
    admin_survey: {
      title: 'Survey',
      add_title: 'Create Survey',
      detail_title: 'Survey Detail',
      survey_link: 'Survey Link',
      title_en: 'Title (English)',
      title_zh: 'Title (Chinese)',
      start: 'Survey Start',
      end: 'Survey End',
      require_login: 'Require User Login',
      description_en: 'Survey Description（English）',
      description_zh: 'Survey Description（Chinese）',
      questions: 'Questions',
      response_count: 'No. of Response',
      add_single_line_question: 'Add Single Line Question',
      add_freetext_question: 'Add Free Text Question',
      add_rating_question: 'Add Rating Question',
      question_type: 'Question Type',
      question_title_en: 'Question (English)',
      question_title_zh: 'Question (Chinese)',
      question_max_label_en: 'Label for 5（English）',
      question_max_label_zh: 'Label for 5（Chinese）',
      question_min_label_en: 'Label for 1（English）',
      question_min_label_zh: 'Label for 1（Chinese）',
      question_required: 'Required',
      user_input: 'Answer',
      single_line: 'Single Line',
      freetext: 'Free Text',
      rating: 'Rating',
      delete_msg: 'Confirm Delete Survey？',
      save_success_msg: 'Survey Saved',
      publish_survey: 'Publish Survey',
      confirm_publish_msg: 'Confirm sending survey email to ALL users?',
    },
    admin_home_page: {
      title: 'Home Page Setting',
      top_carousel: 'Event for Top Carousel',
      category_event: 'Cover Events for Categories',
      leisure_event: 'Leisure Class',
      seminar_event: 'Seminar',
      mega_event: 'Mega Event',
      memorable_moment: 'Memorable Moment',
      upcoming_events: 'Upcoming Events',
      banner: 'Pop-up Banner',

      maintenance_mode: 'Maintenance Mode',
      maintenance_status: 'Current Status',
      maintenance_enabled: 'Enabled from {create_at}',
      maintenance_disabled: 'Disabled',
      start_maintenance: 'Enable Maintenance Mode',
      end_maintenance: 'Disable Maintenance Mode',
      confirm_start_maintenance_msg: 'Confirm Enable Maintenance Mode?',
      confirm_end_maintenance_msg: 'Confirm Disable Maintenance Mode?',
    },
    admin_check_in: {
      title: 'Check In',
      event: 'Event',
      select_event: 'Select Event',
      session: 'Session',
      select_session: 'Select Session',
      scan_qr_code: 'Scan QR Code',
      invalid_token: 'Invalid QR Code',
      token_expired: 'QR Code Expired',
      confirm_msg: 'Confirm Check In?',
      no_record: 'No Record',
    },
    admin_redeem_welcome_gift: {
      title: 'Redeem Welcome Gift',

      hkiarace_card_no: 'HKIARaCE Card No.',
    },
    admin_report: {
      title: 'Reports',
      registered_user: 'Registered User',
      event_total_hour: 'Category Total Event Hours',
      category_application: 'Application Report',
      event_attendance: 'Attendance Report',
      application_company: 'No. of Company',
      application_user: 'No. of Application',
      application_aa_user: 'No. of AA Application',
      application_non_aa_user: 'No. of Non-AA Application',
      participant_company: 'No. of participating Company',
      participant_aa_user: 'No. of AA participant',
      participant_non_aa_user: 'No. of Non-AA participant',
      participant_user: 'No. of Participant',
      attendance_user: 'Attendance',
      interval_month: 'By Month',
      interval_year: 'By Year',
      special_offer_count: 'No. of Special Offer',
      special_offer_view_count: 'No. of Special Offer View',
      corporate_vendor_view_count: 'No. of Corporate Vendor View',
      show_report: 'Show Report',

      acc_booking_report: 'Booking Report',
      confirmed: 'No. of Confirmed Booking',
      cancelled_by_user: 'No. of Booking Cancelled by User',
      cancelled_by_admin: 'No. of Booking Cancelled by Admin (Not refunded)',
      refunded: 'No. of Booking Refunded by Admin',
      no_show: 'No. of No-show Booking',

      acc_payment_report: 'Payment Report',
      octopus_count: 'Octopus Count',
      octopus_amount: 'Octopus Amount',
      cyber_source_count: 'Visa / Master / Jetco Count',
      cyber_source_amount: 'Visa / Master / Jetco Amount',
      union_pay_count: 'Union Pay Count',
      union_pay_amount: 'Union Pay Amount',
      coupon_count: 'Voucher Count',
      coupon_amount: 'Voucher Amount',

      no_grouping: 'Total Count',
      all_categories: 'All (Group by Categories)',
      all_events: 'All (Group by Events)',
      all_regions: 'All (Group by Areas)',
      all_facility_types: 'All (Group by Facility Types)',

      acc_income_report: 'Monthly Income Report',
      daily_acc_usage_report: 'Daily Facility Utilisation Report',
      monthly_acc_usage_report: 'Monthly Facility Utilisation Report',
      report_recipients: 'Report Recipients',
    },
    admin_tnc: {
      title: 'Terms and Conditions',
      title_en: 'Title (English)',
      content_en: 'Content (English)',
      title_zh: 'Title (Chinese)',
      content_zh: 'Content (Chinese)',
      privacy_title_en: 'Privacy Policy Title (English)',
      privacy_content_en: 'Privacy Policy Content (English)',
      privacy_title_zh: 'Privacy Policy Title (Chinese)',
      privacy_content_zh: 'Privacy Policy Content (Chinese)',
    },
    admin_banner: {
      add_title: 'Add Banner',
      edit_title: 'Edit Banner',
      name: 'Name',
      require_login: 'Shown to Logged-in Users',
      path: 'Display Path',
      from_time: 'Display From',
      to_time: 'Display Until',
      banner_en: 'Banner Image (English)',
      banner_zh: 'Banner Image (Chinese)',
      link_en: 'URL (English)',
      link_zh: 'URL (Chinese)',
      with_content: 'With Text Content',
      content_en: 'Text Content (English)',
      content_zh: 'Text Content (Chinese)',
    },

    admin_acc: {
      dashboard: 'Dashboard',
      booking: 'Bookings',
      recurrent_booking: 'Recurring Bookings',
      purchase_order: 'Purchase Orders',
      invoice: 'Invoices',
      member: 'Users',
      facility: 'Facilities',
      gym: 'Gym',
      package: 'Package',
      discount_code: 'Discount Code',
      coupon_group: 'Voucher Group',
      region: 'Region',
      email_templates: 'Email Templates',
    },
    admin_acc_booking: {
      title: 'Bookings',
      export: 'Export',
      add: 'Create Booking',
      reference_number: 'Ref. No.',
      payment_reference_number: 'Ref. No. for Payment',
      reserved_at: 'Reserved At',
      datetime: 'Booking Time',
      date: 'Date',
      time: 'Time',
      start_time: 'Start Time',
      end_time: 'End Time',
      facility: 'Facility',
      checkin_time: 'Check-in Time',
      checkout_time: 'Check-out Time',
      second_contact_number: 'User Contact No.',
      remarks: 'Remarks',
      status: 'Status',
      not_checked_in: 'Not Checked-in',
      checked_in: 'Checked-in',
      cancel: 'Cancel Booking',
      confirm_cancel_msg: 'Confirm Cancel Booking?',
      refund: 'Refund Booking',
      confirm_refund_msg: 'Confirm Refund Booking?',
      check_in: 'Check-In',
      confirm_checkin_msg: 'Confirm Check-in?',
      uncheck_in: 'Undo Check-In',
      confirm_uncheckin_msg: 'Confirm Undo Check-in?',
      cancel_success_msg: 'Booking Cancelled',
      checkin_success_msg: 'Check-in Successful',
      uncheckin_success_msg: 'Uncheck-in Successful',
      save_remarks: 'Save Remarks',
      save_remarks_success_msg: 'Remarks Successfully Saved',

      check_in_title: 'Facility Check-in',
      check_in_scan_title: 'Scan Booking or User QR Code',
      check_in_scan_user_title: 'Scan User QR Code',

      add_additional_item_title: 'Add Additional Items',
      add_additional_item_confirm_msg: 'Confirm adding selected additional items to booking?',
      add_additional_item_success_msg: 'Additional Items Added Successfully',

      with_purchase_order: 'With PO',
    },
    admin_acc_recurrent_booking: {
      edit_title: 'Recurrent Booking Details',

      reserved_at: 'Reserved At',
      reference_number: 'Ref. No.',
      recurrent_title: 'Recurrence Title',

      quick_create_po: 'Quick Create PO',
    },
    admin_acc_booking_add: {
      title: 'Create Booking',
      facility_type: 'Facility Type',
      facility: 'Facility',
      type: 'Booking Type',
      user_booking: 'User Booking',
      maintenance_booking: 'Maintenance',
      maintenance_title: 'Maintenance Reason',
      date: 'Booking Date',
      from_time: 'Booking Start Time',
      to_time: 'Booking End Time',
      start_time: 'Start Date & Time',
      end_time: 'End Date & Time',
      user: 'User',
      is_recurring: 'Recurring Booking',
      recur_title: 'Recurrence Title',
      recur_start_date: 'Recurring Start Date',
      recur_end_date: 'Recurring End Date',
      repeat_every: 'Repeat Every',
      repeat_interval: 'Repeat Interval',
      repeat_every_day: 'Day',
      repeat_every_week: 'Week',
      repeat_every_month: 'Month',
      recur_start_time: 'Recurrence Start Time',
      recur_end_time: 'Recurrence End Time',
      recur_replace_booking: 'Replace Existing Booking',
      recur_select_other_option: 'Select Other Venue',
      recur_cancel_booking: 'Cancel this occurrence',
      waive_fee: 'Waive Booking Fee',
      fee: 'Booking Fee',
      maintenance_from_date: 'Maintenance From',
      maintenance_to_date: 'Maintenance Until',
      remarks: 'OSS',
      booking_cancel_success_msg: 'Booking cancelled successfully',
      refund_all_warning: 'All remaining affected bookings will be cancelled! Please confirm.',
      success_msg: 'Maintenance Booking Added Successfully',
      add_maintenance_booking: 'Add Maintenance Booking',
      add_user_booking: 'Add User Booking',
    },
    admin_acc_member: {
      title: 'Users',
    },
    admin_acc_facility_type: {
      title: 'Facility Type',
      add_title: 'Add Facility Type',
      edit_title: 'Facility Type Details',
      no_item: 'No Facility Type',
      name_en: 'Name (English)',
      name_zh: 'Name (Chinese)',
      description_en: 'Description (English)',
      description_zh: 'Description (Chinese)',
      open_for_booking: 'Open for Booking',
      auto_assign_items: 'Auto Assign Items',
      duration: 'Duration (Minute)',
      fee: 'Fee',
      per_session: 'Per Session',
      with_quota: 'With Quota',
      icon: 'Icon',
      banner: 'Banner',
      photo: 'Photo',
      show_congestion_status: 'Show Congestion Status',
      confirm_delete_msg: 'Confirm Delete Item Types?',
      save_success_msg: 'Item Type Info has been saved',

      price_tiers: 'Price Tiers',
      additional_items: 'Additional Items',
      day_schedule: 'Day Schedules',
      week_schedule: 'Schedule Placement',
      adhoc_week_schedule: 'Adhoc Schedule Placement',
      calendar: 'Schedule Review',
    },
    admin_acc_item_type_additional_item: {
      add_title: 'Add Additional Item',
      edit_title: 'Edit Additional Item',

      name_en: 'Name (English)',
      name_zh: 'Name (Chinese)',
      price: 'Fee',
      max_per_booking: 'Max. No. of Item Per Booking',
      icon: 'Icon',
    },
    admin_acc_price_tier: {
      name: 'Name',
      name_en: 'Name (English)',
      name_zh: 'Name (Chinese)',
      price: 'Price',
      add_title: 'Add Price Type',
      edit_title: 'Edit Price Type',
      confirm_delete: 'Confirm Delete Price Tier?',
      legend: 'Legend',
      legend_en: 'Legend (English)',
      legend_zh: 'Legend (Chinese)',
    },
    admin_acc_day_schedule: {
      name: 'Name',
      add_title: 'Add Day Schedule',
      edit_title: 'Edit Day Schedule',
      select_schedule: 'Select a schedule to start',
      confirm_delete: 'Confirm Delete Day Schedule?',
      add_session_title: 'Add Timeslot',
    },
    admin_acc_week_schedule: {
      day_1: 'MON',
      day_2: 'TUE',
      day_3: 'WED',
      day_4: 'THU',
      day_5: 'FRI',
      day_6: 'SAT',
      day_7: 'SUN',
      public_holiday_schedule: 'Public Holiday',
    },
    admin_acc_adhoc_week_schedule: {
      add_title: 'Add Adhoc Week Schedule',
      name: 'Name',
      priority: 'Priority',
      valid_from: 'Valid From',
      valid_until: 'Valid Until',
    },
    admin_acc_gym_subscription_type: {
      title: 'Gym Pass Types',
      add_title: 'Add Gym Pass Types',
      edit_title: 'Edit Gym Pass Types',
      name_en: 'Name (English)',
      name_zh: 'Name (Chinese)',
      description_en: 'Descriptions (English)',
      description_zh: 'Descriptions (Chinese)',
      price: 'Price',
      can_reserve: 'Reservation Enabled',
      valid_for_uses: 'Valid for No. of Uses (-1: Unlimited)',
      valid_for_days: 'Valid for No. of Days (-1: Unlimited)',
    },
    admin_acc_gym_subscription: {
      title: 'Gym Pass',
      check_in_title: 'Check In Gym Pass',
    },
    admin_acc_gym_booking: {
      title: 'Gym Reservation',
    },
    admin_acc_gym_checkin: {
      title: 'Gym Check-in',
      scan_qr_code: 'Scan User QR Code',
      has_booking: 'Booking / Walk-in',
      booking_time: 'Reservation Time',
      booking: 'Booking',
      walkin: 'Walk-in',
      walkin_capacity: 'Walk-in Capacity',
      account_pic: 'User Picture',
      scan_white_card: 'Scan White Card QR Code',
      success_msg: 'Card ID: A{card_id}, Check-in Successful',
    },
    admin_acc_package_page: {
      title: 'Package Listing',

      banner: 'Banner',
      header_en: 'Header (English)',
      header_zh: 'Header (Chinese)',
      subheader_en: 'Sub-Header (English)',
      subheader_zh: 'Sub-Header (Chinese)',
      content_en: 'Content (English)',
      content_zh: 'Content (Chinese)',
      footer_en: 'Footer (English)',
      footer_zh: 'Footer (Chinese)',
    },
    admin_acc_package_type: {
      title: 'Package Type',
      add_title: 'Create Package Type',
      edit_title: 'Edit Package Type',

      link: 'Package Link',
      name_en: 'Name (English)',
      name_zh: 'Name (Chinese)',
      banner: 'Banner',
      description_en: 'Description (English)',
      description_zh: 'Description (Chinese)',
      price: 'Price',
      content: 'Package Content',
      valid_from: 'Available From',
      valid_until: 'Available Until',

      add_content: 'Add Content',
      remove_content: 'Remove Content',
      invalid_valid_until: 'Please enter valid end date',

      content_type: 'Content Type',
      point: 'Amount of Loyalty Point',
      coupon_item_type: 'Facility Type',
      coupon_count: 'No. of Coupon(s)',
      coupon_amount: 'Coupon Amount',
      coupon_valid_until: 'Coupon Valid Until',

      delete: 'Delete Package Type',
      show_package: 'Purchase Records',
      confirm_delete_msg: 'Confirm Delete Package Type?',
    },
    admin_acc_package: {
      title: 'Package Purchases',

      create_at: 'Purchased At',
      account: 'User',
      type: 'Package Type',
      status: 'Status',
    },
    admin_acc_location: {
      title: 'Location',
      add_title: 'Add Location',
      edit_title: 'Location Details',
      no_location: 'No Location',
      name_en: 'Name (English)',
      name_zh: 'Name (Chinese)',
      address_en: 'Address (English)',
      address_zh: 'Address (Chinese)',
      opening_hours: 'Opening Hours',
      follow_parent_hours: 'Follow Parent Opening / Closing Hours',
      opening_hour: 'Opening Hour',
      closing_hour: 'Closing Hour',
      confirm_delete_msg: 'Confirm Delete Location？',
      save_success_msg: 'Location Info has been saved',
    },
    admin_acc_region: {
      title: 'Area',
      add_title: 'Add Area',
      edit_title: 'Area Details',
      no_region: 'No Region',
      no_item: 'No Area',
      name_en: 'Name (English)',
      name_zh: 'Name (Chinese)',
      location: 'Location',
      opening_hours: 'Opening Hours',
      follow_parent_hours: 'Follow Parent Opening / Closing Hours',
      opening_hour: 'Opening Hour',
      closing_hour: 'Closing Hour',
      confirm_delete_msg: 'Confirm Delete Area？',
      save_success_msg: 'Area Info has been saved',
      exclusion: 'Exclusion',
    },
    admin_acc_item_type: {
      regenerate_sessions: 'Regenerate Sessions',
    },
    admin_acc_item: {
      title: 'Facility',
      add_title: 'Add Facility',
      edit_title: 'Facility Detail',
      no_item: 'No Facility',
      name_en: 'Name (English)',
      name_zh: 'Name (Chinese)',
      location: 'Location',
      region: 'Region',
      item_type: 'Facility Type',
      opening_hours: 'Opening Hours',
      follow_parent_hours: 'Follow Parent Opening / Closing Hours',
      opening_hour: 'Opening Hour',
      closing_hour: 'Closing Hour',
      confirm_delete_msg: 'Confirm Delete Facility？',
      save_success_msg: 'Facility Info has been saved',
    },
    admin_acc_settings: {
      title: 'Settings',
      in_advance_booking_period: 'In-advance Booking Period (Days)',
      booking_limit_user: 'Maximum Number of Session Per User',
      booking_limit_day: 'Maximum Number of Session Per User Per Day',
      booking_limit_month: 'Maximum Hour of Reservation Per Month',
      no_show_penalty_limit: 'Maximum count of No-show before suspension',
      no_show_penalty_period: 'No-show counting period (Days)',
      no_show_penalty_suspension_period: 'No-show suspension period (Days)',
      booking_reminder: 'Booking reminder email period (Days)',
      coupon_expiry_period: 'Voucher expiration period (Days)',
      acc_membership_price: 'Membership Price (HKD)',
      acc_membership_period: 'Membership Period (Days)',
      hkiarace_membership_renew_reminder: 'HKIARaCE ID renew reminder email period (Days)',
      acc_point_top_up_options: 'Loyalty Points Top Up Tiers',
      top_up_tier_price: 'Price',
      top_up_tier_amount: 'Loyalty Points',
      add_top_up_tier: 'Add Tier',
      acc_point_exchange_rate: 'Point Exchange Rate',
      acc_max_gym_reservation: 'Gym Room Reservation Limit',
      acc_max_gym_capacity: 'Gym Room Total Capacity（Reservation + Walk-in）',
      confirm_save_msg: 'Confirm saving settings?',
      settings_saved: 'Settings Saved',
    },
    admin_acc_email_template: {
      title: 'Email Template',
    },
    admin_acc_public_holiday: {
      title: 'Public Holiday',
      add_title: 'Add Public Holiday',
      edit_title: 'Edit Public Holiday',
      name: 'Name',
      date: 'Date',
    },
    admin_acc_white_card: {
      title: 'White Card Management',
      detail_title: 'White Card Check In Record',
      add: 'Add New Card',
      add_confirm_msg: 'Confirm Add New Card?',
      export: 'Download QR Code',
      deactivate: 'Deactivate',
      deactivate_confirm_msg: 'Deactivate White Card?',
      reactivate: 'Reactivate',
      reactivate_confirm_msg: 'Reactivate White Card?',

      id: 'Card No.',
      active: 'Active',
      user: 'User',
      booking: 'Facility',

      check_out_title: 'Check Out',
      scan_qr_code: 'Scan White Card QR Code',
      not_check_in: 'White Card Not In Use',
      bookings: 'Facility Bookings',
      gym_check_ins: 'Gym Check In Records',
      check_out_confirm_msg: 'Confirm Check Out?',
      check_out_success_msg: 'Checked Out Successfully',
    },
    admin_acc_check_in: {
      title: 'Facility Check-In',
      bookings: 'Bookings',
      white_cards: 'White Cards',
      confirm_msg: 'Check-in {booking_count} Booking(s) with {white_card_count} White Card(s)?',
    },
    admin_acc_purchase_order: {
      add_title: 'Create Purchase Order',
      edit_title: 'Purchase Order Details',

      id: 'PO No.',
      created_by: 'Created By',
      recipient: 'Recipient',
      recipient_hkiarace_no: 'HKIARaCE No. of Recipient',
      issued_at: 'Issued Date',
      due_at: 'Due Date',
      title: 'Title',
      remarks: 'Remarks',
      amount: 'Total Amount',
      paid: 'Paid Amount',
      due: 'Due Amount',
      status: 'Status',

      bookings: 'Bookings',
      select_all_bookings: 'Select All',
      remove_bookings: 'Remove',
      add_bookings: 'Add Bookings',
      add_recurrent_bookings: 'Add Recurrent Bookings',

      delete_confirm_msg: 'Delete PO?',

      invoices: 'Invoices',
    },
    admin_acc_invoice: {
      add_title: 'Create Invoice',
      edit_title: 'Invoice Details',

      invoice_no: 'Invoice #',
      issued_at: 'Issued Date',
      due_at: 'Due Date',
      title: 'Title',
      details: 'Details',
      amount: 'Amount',
      status: 'Status',
      remarks: 'Remarks',
      save_remarks: 'Save Remarks',

      bookings: 'Bookings',

      item: 'Item',
      unit_price: 'Unit Price',
      quantity: 'Qty.',
      subtotal: 'Subtotal',
      generate_from_bookings: 'Generate From Selected Bookings',
      discount_percentage: 'Discount %',
      discount_amount: 'Discount Amount',
      total: 'Total',

      payment: 'Payment',

      delete_confirm_msg: 'Delete Invoice?',

      send: 'Send',
      send_confirm_msg: 'Send Invoice to Recipient?',
      send_success_msg: 'The invoice is sent successfully',

      payment_method: 'Payment Method',
      payment_proof: 'Payment Proof',

      approve: 'Approve',
      approve_confirm_msg: 'Approve Payment?',

      setting_title: 'Purchase Order / Invoice',
      invoice_pdf_footer: 'Invoice PDF Footer',
      invoice_bank_transfer_payment_instructions: 'Invoice Payment Instructions - Bank Transfer ',
      invoice_cheque_payment_instructions: 'Invoice Payment Instructions - Cheque',
      receipt_pdf_footer: 'Receipt PDF Footer',
    },
    admin_acc_discount_code: {
      code: 'Code',
      start: 'Start Date',
      end: 'End Date',
      type: 'Type',
      type_FACILITY: 'Facility Booking',
      type_GYM_PASS: 'Gym Pass',
      type_MEMBERSHIP: 'Annual Membership Subscription',
      item_type: 'Facility Type',
      gym_pass_type: 'Gym Pass Type',
      minimum_amount: 'Minimum Order Amount',
      discount: 'Discount',
      discount_value: 'Discount Value',
      discount_percentage: 'Discount Percentage',
      change_discount_type: 'Change Type',
      quota: 'Total No. of Use',
      use_per_account: 'No. of Use per Account',
      infinite: 'Infinite Use',

      add_title: 'Create Discount Code',
      edit_title: 'Discount Code Detail',
      list_records: 'Usage Record',
      list_record_title: 'Discount Code Usage',

      delete_confirm_msg: 'Confirm to Delete?',
    },
    admin_acc_discount_code_record: {
      created_at: 'Date',
    },
    admin_acc_coupon: {
      account: '',
      valid_until: 'Expiry Date',
      amount: 'Discount Amount',
      redeem_code: 'Redeem Code',
      redeemed: 'Redeemed',
      redeemed_at: 'Redeemed At',
      quantity: 'Quantity',

      type: 'Type',
      type_FACILITY: 'Facility Booking',
      type_GYM_PASS: 'Gym Pass',
      type_MEMBERSHIP: 'Annual Membership Subscription',

      edit_title: 'Edit Voucher Expiry Date',
    },
    admin_acc_coupon_group: {
      add_title: 'Create Voucher Group',
      edit_title: 'Voucher Group Detail',
      add_coupon_title: 'Create Vouchers',
      assign_title: 'Assign Vouchers',
      assign_user: 'Assign Vouchers to User',

      name: 'Name',

      delete_confirm_msg: 'Delete Voucher Group?',
    },

    notification_record: {
      title: 'Notification Record',
      create_at: 'Date',
      template: 'Template',
      type: 'Type',
      email: 'Email',
      push_notification: 'Push Notification',
      toggle_email_details: 'Toggle Email Details',
      email_subject: 'Subject',
      email_content: 'Content',
    },

    jwt_scanner: {
      scanner_hint: 'Scan QR Code using Scanner',
      or: 'OR',
      webcam_label: 'Scan QR Code using Web Cam',
      manual_input_hint: 'Manually Input and press Enter on your keyboard',
    },
    camera_capture: {
      fallback: 'UPLOAD',
      capture: 'CAPTURE',
    },
    // Constants
    languages: {
      en: 'English',
      'zh-Hant': 'Cantonese',
      'zh-Hans': 'Mandarin',
    },
    event_signup_mode: {
      disabled: "DISPLAY ONLY",
      single_session: "SINGLE SESSION",
      multi_session: "MULTI-SESSION",
      multi_series: "MULTI-SERIES",
    },
    email_template_types: {
      registration_ack: 'Registration Complete',
      email_verification: 'Email Verification',
      new_device_otp: 'New login OTP',
      reset_password: 'Reset Password',
      id_verification_ack: 'ID Submitted for Verification',
      id_verification_success: 'ID Verification Accepted',
      id_verification_success_with_gift: 'ID Verification Accepted (With Welcome Gift)',
      id_verification_fail: 'ID Verification Rejected',
      id_verification_remind: 'ID Verification Renew Reminder',
      event_enrollment_ack: 'Enrollment Acknowledgement',
      event_payment_confirmation: 'Payment Confirmation',
      old_member_invite: 'Old User Invitation',

      booking_confirmation: 'Booking Confirmation',
      booking_reminder: 'Booking Reminder',
      booking_cancellation: 'Booking Cancellation',
      member_suspension: 'User Suspension',
      bbq_option_admin: 'BBQ Option (User)',
      bbq_option_user: 'BBQ Option (Admin)',
      gym_pass_confirmation: 'Gym Pass Confirmation',
      package_confirmation: 'Package Confirmation',
      membership_confirmation: 'Membership Confirmation',
      point_top_up: 'Loyalty Point Confirmation',
      invoice_sent: 'Purchase Order Invoice',
      invoice_receipt: 'Invoice Receipt',

      REGISTRATION_APPROVED: 'Registration Approved',
      REGISTRATION_REJECTED: 'Registration Rejected',
      PENDING_APPROVAL: 'Pending Manual Approval',
      REGISTRATION_SUSPENDED: 'Registration Suspended',
    },
    event_status: {
      enrolled: 'Enrolled',
      enrollment_ended: 'Enrollment Closed',
      ended: 'Enrollment Closed',
    },
    salutation: {
      mr: 'Mr.',
      mrs: 'Mrs.',
      ms: 'Ms.',
      dr: 'Dr.',
    },
    id_type: {
      ara_permit: 'ARA Permit',
      airport_octopus: 'Airport Octopus Card',
      company_card: 'Company Card',
      personal_octopus: 'Personal Octopus Card + Company Staff Card / ARA Permit',
      AIRPORT_OCTOPUS: 'Airport Octopus Card',
      PERSONAL_OCTOPUS_AND_STAFF_CARD: 'Personal Octopus Card + Company Staff Card',
      VIP: 'VIP',
    },
    id_verification_status: {
      not_verified: 'Not Verified',
      pending_verification: 'Pending Verification',
      verified: 'Verified',
      expired: 'Expired',
    },
    sasv_status: {
      NOT_SUBMITTED: 'PENDING USER SUBMISSION',
      PENDING_APPROVAL: 'PENDING APPROVAL',
      APPROVED: 'APPROVED',
      REJECTED: 'REJECTED',
      SUSPENDED: 'SUSPENDED',
    },
    sasv_source: {
      CANTEEN_REGISTRATION: 'STAFF CANTEEN',
      HKIASC: 'HKIA SC',
      ACA_APP: 'ACA',
      null: 'N/A',
    },
    enrollment_status: {
      pending: 'Registered, Pending for Confirmation',
      accepted: 'Successfully Enrolled',
      rejected: 'Enrollment Unsuccessful',
      pending_payment: 'Pending Payment',
    },
    account_type: {
      operator: 'Assistant',
      admin: 'Manager',
    },
    booking_record_status: {
      pending: 'Pending Payment',
      paying: 'Pending Payment',
      confirmed: 'Confirmed',
      cancelled_by_user: 'Cancelled',
      cancelled_by_admin: 'Cancelled by Admin',
      expired: 'Expired',
      no_show: 'No Show',
    },
    booking_status: {
      available: 'Available',
      excluded: 'Excluded',
      reserved: 'Reserved',
      confirmed: 'Confirmed',
      paying: 'Pending Payment',
      cancelled_by_user: 'Cancelled By User',
      refunded: 'Refunded',
      cancelled_by_admin: 'Cancelled By Admin',
      expired: 'Expired',
      no_show: 'No Show',
      waiting_for_check_in: 'Waiting For Check-in',
      checked_in: 'Checked In',
      created_by_admin: 'Created By Admin',
      create_admin_booking: 'Create Booking',
    },
    facility_congestion_status: {
      title: 'Current Congestion Level: ',
      0: 'Low',
      1: 'Mid',
      2: 'High',
    },
    payment_method: {
      cyber_source: 'Visa / Master / JCB',
      union_pay: 'Union Pay Card',

      bank_transfer: 'Bank Transfer',
      cheque: 'Cheque',
    },
    payment_type: {
      acc_facility_booking: 'Facility Booking',
      acc_membership_extend: 'Membership',
      event_enrollment: 'Event',
      invoice: 'Invoice Payment',
    },
    cyber_source_payment_decision: {
      PENDING: 'PENDING',
      ACCEPT: 'ACCEPTED',
      DECLINE: 'DECLINED',
      REFUND: 'REFUNDED',
      NOT_FOUND: 'CANCELLED',
      ERROR: 'ERROR',
    },
    point_transaction_type: {
      FACILITY_BOOKING: 'Facility Booking',
      TOP_UP: 'Top Up',
      PACKAGE: 'Package',
    },
    package_content_type: {
      point: 'Loyalty Point',
      coupon: 'Facility Coupon',
    },
    invoice_status: {
      DRAFT: 'Draft',
      AWAITING_PAYMENT: 'Awaiting Payment',
      PENDING_CONFIRMATION: 'Pending Confirmation',
      SETTLED: 'Settled',
      VOIDED: 'Voided',
    },
    discount_code_descriptions: {
      minimum_amount: 'over ${amount}',
      discount_value: '${discount}',
      discount_percentage: '{discount}%',
      use_per_account: ' ({count} Use(s) per Account)',

      FACILITY: '{discount} off {item_type} bookings {minimum_amount}{use_per_account}',
      GYM_PASS: '{discount} off {gym_pass_type}{use_per_account}',
      MEMBERSHIP: '{discount} off ASC Membership{use_per_account}',
    },
    error_messages: {
      default: 'Something went wrong. Please try again later',
      duplicate_id_no: 'ID number has been used. Please contact us.',
      incorrect_code: 'Incorrect Verification Code',
      account_suspended: 'Your Account has been suspended',
      id_not_validated: 'Your ID has not been validated',
      acc_not_activated: 'Your HKIARaCE Membership has not been activated. Please pay the fee at "My Account"',
      invalid_booking_id: 'Invalid Booking ID',
      octopus_not_validated: 'Please Map Octopus First',
      validate_email: 'Please validate your email address before continue',
      reuse_password: 'The last 13 passwords cannot be reused',
      booking_limit_reached: 'Booking Limit Reached',
      invalid_number_input: 'Please enter valid value',
      existing_white_card: 'User has already checked in with another White Card',
      white_card_in_use: 'White Card has already been used by other User',
      invalid_white_card_id: 'Please enter valid White Card No.',
      session_taken: 'The selected sessions are not currently available. Please select other sessions or try again later.',

      invalid_discount_code: 'Invalid Discount Code',
      discount_code_quota_full: 'Discount Code Quota Exceeded',
      discount_code_user_quota_full: 'You have reached the maximum usage of this code',
      discount_code_minimum_not_met: 'You have not met the minimum amount to use this Discount Code',
      discount_code_not_applicable: 'Discount Code not applicable to your order',
      invalid_coupon_redeem_code: 'Invalid / Expired Redeem Code',
    },

    add: 'Add',
    and: ' And ',
    search: 'Search',
    all: 'All ',
    cancel: 'Cancel',
    next: 'Next',
    reset: 'Reset',
    finish: 'Finish',
    disable: 'Disable',
    enable: 'Enable',
    delete: 'Delete',
    save: 'Save',
    browse: 'Browse',
    detail: 'Detail',
    minutes: 'Minute(s)',
    checkin: 'Check-in',
    uncheckin: 'Un-Checkin',
    close: 'Close',
    back: 'Back',
    upload: 'Upload',
    continue: 'Continue',
    not_uploaded: 'Not Uploaded',
    not_verified: 'Not Verified',
    unlimited: 'Unlimited',
    edit: 'Edit',
    login_msg: 'Please login before continue',
    logout_msg: 'Are you going to log out the account?',
    submit: 'Submit',
    error_msg: 'Something Went Wrong. Please Try Again Later',
    export: 'Export',
    octopus_not_mapped: 'Please Map Octopus First',
    yes: 'Yes',
    no: 'No',
    name: '{given_name} {surname}',
    date_range: 'Date Range',
    filter: 'Filter',
    clear: 'Clear',
    apply: 'Apply',
    delete_image_confirm_msg: 'Delete Image?',
    copy: 'Copy',
    interval_noon: '12NN',
    interval_format: '{hour}{am_pm}',
    interval_am: 'AM',
    interval_pm: 'PM',
    pay: 'Pay',
    ok: 'OK',
  },
  "zh": {
    title: " | HKIARaCE 機場同業綜藝社",
    header: {
      // Header
      home: '首頁',
      about_us: '關於機場員工會所',
      facility: '設施',
      event: '活動',
      my_booking: '我的預訂',
      my_account: '我的帳號',
      more: '更多',
      help: '幫助',
      logout: '登出',
      login: '登入',
      register: '登記',
      hi: '您好, {surname}{given_name}',
      pay: '付款',
      notifications: '通知',
      exciting_activities: '最新動態',
      sitemap: '網頁指南',
      tnc: '條款及細則',
      privacy: '私隱政策',
      allrights: '©香港機場管理局版權所有',
      facilityOther: '員工會所',
      facilityHall: '體育及多用途活動廳',
      facilityRoom: '多用途活動室',
      shopping_cart: '購物車',
      pricing_info: '會所設施收費表',
    },
    notification: {
      no_notification: '沒有通知',
      see_all: '查看全部',
    },
    home: {
      hkaa_link: 'https://www.hongkongairport.com/tc/',
      description_title: '關於機場員工會所',
      description_sub_title: '機場員工會所',
      description_content: '機場員工會所旨在為機場社區工作的人士提供一個五星級的會所，提供完善的休閒及娛樂設施。',
      all_rights_reserved: '香港機場管理局版權所有',
      join_hkiarace_1: '成為機場同業綜藝社的一份子！',
      join_hkiarace_2: '',
      join_hkiarace_3: '尚未登記？',
      join_hkiarace: '立即加入',

      hot_items: '熱門項目',
      more_facility: '更多',
      upcoming_event: '近期活動',
      more_events: '更多活動',

      coming_soon: '即將啟用',
    },
    about_acc: {
      banner_title: '關於機場員工會所',
      no_of_users: '用戶人數',
      events_held: '已舉辦活動',
      service_hour: '辦公時間',
      no_of_facility: '設施數目',
      total_space: '佔地面積',

      about_hkia_title: '關於機場員工會所',
      about_hkia_sub_title: '機場員工會所',
      about_hkia_content: '機場員工會所旨在為機場社區的香港國際機場73,000名工作的人士提供一個五星級的會所，提供完善的休閒及娛樂設施。',

      vision_title: '',
      vision_sub_title: '機場員工會所',
      vision_content: '機場員工會所兼具休閒及活力的綜合會所，會所提供不同類型的康體及消閒設施，滿足各機場同業的不同需要，設有健身室、卡拉OK室、多用途活動室、閱讀室、休息室、多用途活動廳、燒烤場及空中花園等，讓員工在工餘時間放鬆身心。',

      map_and_location: '聯絡我們',
      map_and_location_content: '機場員工會所<br>香港大嶼山香港國際機場<br>暢達路13號, 機場同業綜合大樓10-11樓<br><br>服務時間:<br> 07:30 - 22:30<br><br>電話:<br> 21881555 / 21881554<br><br>電郵:<br> <a href="mailto:hkiasc@hkairport.com">hkiasc@hkairport.com</a>',

      learn_more: '認識更多',
    },
    register: {
      login_info: '登入資料',
      email: '電郵地址',
      invalid_email: '請輸入有效電郵地址',
      invalid_mobile: '請輸入8位數字',
      mobile: '手提電話號碼(選填)',
      password: '密碼',
      password_contain_eight_characters: '密碼長度至少為8個字元',
      password_contain_letters: '密碼至少含有一個英文字母',
      password_contain_numbers: '密碼至少含有一個數字',
      password_contain_special_characters: '密碼至少含有一個特殊字元 (不含空格)',
      confirm_password: '確認密碼',
      password_match: '確認密碼',

      basic_info: '基本資料',
      salutation: '稱謂',
      surname_zh: '機場員工八達通卡的中文姓氏',
      given_name_zh: '機場員工八達通卡的中文名字',
      surname_en: '機場員工八達通卡的英文姓氏',
      given_name_en: '機場員工八達通卡的英文名字',
      only_input_english_characters: '請只輸入英文字母',
      company: '公司',
      cannot_find_company: '找不到您的公司？',
      other_company_name: '公司名稱',

      sasv_info: '機場工作人員身份',
      octopus_no: '8 - 10位機場員工八達通卡號',
      octopus_no_hint: '（包括括號內的數字）',
      incorrect_octopus_no: '請輸入8 - 10位機場員工八達通卡號',

      tnc: '如要登記成為機場同業綜藝社之友請查閱和同意我們的條款及細則',
      require_tnc: '請同意',
      disagree: '不同意',
      agree: '同意',

      require_captcha: '請完成認證',

      enter_required_field: '請輸入此必填項',
      select_company: '請選擇公司',
      required_fields: '必須填寫',

      name: '八達通卡上的全名',

      octopus_front: '機場員工八達通卡 (正面)',
      octopus_back: '機場員工八達通卡 (背面)',
      staff_card_front: '員工證 (正面)',
      staff_card_back: '員工證 (背面)',

      ocr_fail_msg: '系統未能辨認機場八達通，請重新拍攝。',

      id_front: '公司職員證 / 機場禁區證 (正面)',
      id_back: '公司職員證 / 機場禁區證 (背面)',

      review: '確認',

      registration_complete_details: '您已成功登記，可於登記成功三十分鐘後使用已註冊的八達通卡進入機場員工餐廳。',

      complete: '註冊成功',
      success_msg: '認證結果將會經由電郵通知閣下。',
      back_to_home: '返回主頁',

      canteen_upsell: '您可進入機場員工餐廳',
      canteen_btn: '前往',
      aca: 'Stay Tuned!',
      aca_subtitle: 'Download the HKG Community App now to get latest discounts.',
    },
    check_status: {
      title: '查詢登記狀況',

      octopus_no: '八達通卡號碼',
      name: '英文全名 (on Octopus Card)',
      status: '狀態',
      validated_at: '認證日期',
      rejected_at: '拒絕日期',
      suspended_at: '停用日期',

      pending: '等待審批',
      pending_msg: '您的登記正在等待驗證，請等待。',
      approved: '已認證',
      approved_msg: '您已成功登記，可於登記成功三十分鐘後使用已註冊的八達通卡進入機員工餐廳。',
      rejected: '已拒絕',
      rejected_msg: '您的登記已被拒絕',
      suspended: '已停用',
      suspended_msg: '您的登記已被停用',
    },
    device_verification: {
      title: '雙重認證',
      content: '我們已發送6位數字的認證碼到你登記的電郵。請在收到電郵後，輸入6位數字認證碼。',
      second_factor_code: '認證碼',
      remember_device: '180天內信任此電腦',
      incorrect_code: '認證碼錯誤',
    },
    email_verify_init: {
      title: '電郵認證',
      content: '一封附有認證連結的電郵已發送到你所登記之電郵地址。請根據指示完成認證後重新登入。',
      resend: '重新發送認證電郵',
    },
    email_verify: {
      success_msg: '多謝完成郵箱認證，你現在可以盡情享受機場同業綜藝社之精彩活動',
      error_msg: '連結已失效',
    },
    login: {
      title: '登入',
      username: '電郵地址',
      password: '密碼',
      forgot_password: '忘記密碼?',
      locked_account_error: '因過多次登入失敗，帳號已被鎖定一小時',
      disabled_account_error: '帳號已被停用',
      wrong_password: '錯誤電郵或密碼',
    },
    remind_change_password: {
      modal_title: '提醒',
      modal_content: '你已經90天沒有更新密碼',
      skip: '略過',
      change_password: '現在更改',
    },
    id_verification: {
      title: '身份認證',
      // description: '你需要提供以下其中一種文件以完成帳戶登記程序',
      description: '請提供所需身份證明以完成帳戶登記',
      verify_later: '稍後認證',
      ara_permit_expiry_date: '機場禁區證到期日',
      suffix_number: '八達能卡號碼',
      front: '正面',
      back: '背面',
      success_title: '機場同業綜藝社用戶身份證証成功!',
      success_description: '恭喜！你的身份證証已完成。你現在可以盡情享受機場同業綜藝社之精彩活動',
      pending_title: '申請等待審批',
      pending_description: '您所提交的機場員工身份證明正等待管理員審批，申請批准後會經電郵通知閤下，請留意電郵，謝謝!.',
      duplicate_id_no: '禁區證編號已被使用。請與我們聯絡',
    },
    reset_password_init: {
      modal_title: '重置密碼',
      modal_content: '重置密碼郵件已傳送至你的電郵',
    },
    reset_password: {
      title: '重置密碼',
      email: '電郵地址',
      modal_title: '重置密碼',
      modal_content: '密碼已重置，請以新密碼重新登入',
      error_msg: '連結已失效',
    },

    //Pre Reg
    pre_reg: {
      text_1: '新建成的機場員工會所',
      text_2: '機場員工獨享',
      text_3: '未登記成為機場同業綜藝社?',
      join_now: '立即登記',
      coming_soon: '快   將   開   幕',
    },

    // HKIARaCE
    event: {
      date: '日期',
      time: '時間',
      location: '地點',
      quota: '名額',
      languages: '語言',
      fee: '費用',
      remarks: '備註',
      download_poster: '下載海報',
      download_attachment: '下載附件',
      enroll: '報名',
      free: '免費',
      show_past_moment: '精彩時刻',
      prev_event: '上一個活動',
      next_event: '下一個活動',
      session: '場次',
      select_session: '選擇場次',
      series: '系列',
      select_series: '選擇系列',
      meta: '報名人數',
      email_not_validated: '電郵未認證',
      invalid_id: '證件未認證',
      enroll_confirm_msg: '確定報名？',
      input_fee_msg: '請選擇參加人數',
      input_session_msg: '請選擇參加場次',
      no_event_msg: '暫時沒有相關的活動提供，請瀏覽',
      no_event_msg_link: '精彩時刻',
      quota_template: '{quota}人',
    },
    enrollment_success: {
      title: '登記完成',
      description: '機場同業綜藝社會將結果以電郵通知您',
    },
    my_account: {
      account_info: '我的帳號',
      serial_no: 'HKIARaCE 編號',
      name_en: '英文名稱',
      name_zh: '中文名稱',
      mobile: '手提電話號碼',
      change_email: '更改',
      change_email_title: '更改電郵',
      change_email_otp: '一次性密碼',
      change_email_send_otp: '發送一次性密碼',
      change_email_otp_resend_countdown: '{second}秒後重發',
      click_to_show_qr_code: '按圖片顯示二維碼',
      sasv_status: '機場工作人員驗證',
      go_verify_sasv: '驗證',


      past_event: '我的活動',


      change_password: '更改密碼',
      info_saved: '成功儲存',
      incorrect_password: '密碼錯誤',
      email_verified_at: '電郵認證狀態',
      verified_at_template: '已於 {date} 完成認證',
      id_verified_at: '八達通認證狀態',
      go_verify_id: '認證',
      enter_password: '輸入密碼以儲存修改',
      membership_valid_until: '八達通認證有效期至',
      card_title: 'HKIARaCE',
      member_name: '{surname}{given_name}',
      my_booking: '我的預訂',
      octopus_mapped_at: '已綁定八達通於',
      octopus_id: '已綁定八達通號碼',
      acc_membership_valid_until: '會籍有效期至',
      acc_membership_expired: '已失效',
      acc_membership_price: '機場員工會所年費（港幣）',
      pay_acc_membership: '付款',
      confirm_pay_acc_membership: '我們將引導您到付款頁面，付款完成後，您會再被引導回此網站',
      coupon: '使用證',
      map_octopus_error: '你需要先認證機場八達通卡方可啟用會籍',
      gym_subscriptions: '健身室通行證',
      gym_subscriptions_checkin: '健身室通行證使用記錄',
      gym_bookings: '健身室預訂',
      points: '積分',
      point_balance: '積分結餘',
      point_transactions: '積分紀錄',
      topup: '增值',
      package: '禮包購買紀錄',
      invoice: '發票',

      octopus_privilege1: '機場員工餐廳',
      octopus_privilege2: '機場同業綜藝社之友',
      octopus_privilege3: '機場員工會所會員',

      receive_promotional_email: '接收市場推廣電郵',
    },
    change_password: {
      title: '更改密碼',
      current_password: '現有密碼',
      new_password: '新密碼',
      confirm_password: '確認新密碼',
      success_msg: '密碼更改成功，請以新密碼重新登入'
    },
    my_event_list: {
      title: '我的活動',
      year: '活動年份',
      category: '活動種類',
      no_event: '沒有活動',
      pay_amount: '金額',
      pay: '付款',
      start_survey: '開始問卷',
      payment_success: '付款成功',
      payment_fail: '付款失敗',
      summary: '付款詳情',
      detail_title: '報名詳情',
    },
    past_event: {
      title: '精彩時刻',
    },
    promotion: {
      title: '購物',
      banner: '購物及員工特別優惠',
      login: '立即登記或登入帳戶<br>隨時隨地盡情購物',

      special_offer: '特別優惠',
      shopping: '購物',
    },
    survey: {
      error_msg: '連結已過期或發生未知錯誤，請稍後重試。',
      complete_msg: '問卷已完成，多謝您寶貴的意見。',
    },

    // ASC
    facility: {
      reserve_now: '立即預訂',
      bought_one_time_pass: '已購買單次門票',
      buy: '購買',
      view: '查看',
      available_choices: '可預訂時段: ',
      facility: '設施',
      date_and_time: '日期及時間',
      max_session_length_msg: '您每次只可預訂最多{length}小時之設施',
    },
    booking: {
      reference_number: '參考編號',
      reserved_at: '保留時間',
      select_venue: '選擇設施',
      facility: '設施',
      date: '日期',
      time: '時間',
      coupons: '使用證',
      no_coupon: '不使用使用證',
      duplicate_coupon: '使用證已用於其他預訂',
      no_booking: '沒有預訂設施',
      discount_code: '優惠碼',
      clear_discount_code: '移除優惠碼?',
      fee: '費用',
      need_bbq_option: '預訂燒烤包',
      second_contact_number: '備用聯絡電話',
      status: '狀態',
      create_at: '預訂時間',
      payment_method: '付款方式',
      pay_by_point: '以積分付款',
      no_need_to_pay: '毋須付款',
      invalid_second_contact_number: '請輸入有效電話號碼',
      tnc_scroll_to_bottom: '',

      available: '可預訂',
      unavailable: '未能預訂',

      step_1: '選擇日期及時間',
      step_2: '預覽預訂',
      step_3: '付款',
      quick_checkout: '快速付款',
      add_to_cart: '添加至購物車',
      next_step: '下一步',

      select_additional_items: '附加項目',

      acc_not_activated: '會籍未生效。請按下"付款"以升級',
      acc_suspended: '因為你多次沒有使用預訂設施，你的會籍已被暫時停用',
    },
    booking_preview: {
      preview_warning: '請於十分鐘內完成付款，否則預訂將被取消',
      booking_preview: '預訂預覽',
      time_left: '剩餘時間: ',
      accept_tnc1: '我已閲讀並同意',
      accept_tnc2: '條款及細則',
      redirect_warning: '我們將引導您到付款頁面，付款完成後，您會再被引導回此網站',
      order_expired_msg: '預訂已被取消，請重新預訂',
      add_payment_token: '新增信用卡',
      checkout: '付款',
    },
    booking_confirm: {
      date: '日期',
      time: '時段',
      item: '設施',
      price: '收費',
      additional_items: '附加項目',

      confirm_msg: '您的預訂已被確認',
      summary: '預訂詳情',
    },
    booking_failure: {
      failure_msg: '付款失敗，請重試',
      request_ref_no: '參考編號',
    },
    booking_detail: {
      title: '預訂詳情',
      cancel_booking: '取消預訂',
      refund_booking: '退款',
      cancel_booking_confirm_msg: '確認取消預訂？',
    },
    coupon: {
      create_at: '發出日期',
      amount: '使用證金額',
      facility: '原有預訂',
      item_type: '設施類別',
      valid_until: '有效期至',
      used_at: '兑換日期',
      no_coupon: '沒有使用證',

      redeem_title: '換領使用證',
      redeem_code: '輸入換領碼',
      redeem_success_msg: '換領成功',
    },
    gym_booking: {
      status: '健身室預訂情況',
      availability: '預訂位置',
      available: '空閒',
      almost_full: '繁忙',
      full: '已滿',
      booked_already: '已預訂',
      reserve: '預訂',
      reserve_title: '確認',
      reserve_msg: '確認預訂選定日期？',
      success_title: '成功預訂',

      date: '預訂日期',
      reference_number: '參考編號',
      account: '用戶',
      checkin_time: '已簽到',
      booking_status: '預訂狀態',

      cancel_confirm_msg: '確認取消預訂?',
    },
    gym_subscription: {
      name: '健身室',
      title: '健身室通行證',
      // question_consent: '你明白怎樣使用這些健身器械嗎？',
      // consent: '我明白怎樣使用這些健身器械',
      question_consent: '我明白健身室的使用守則。',
      consent: '我明白健身室的使用守則。',
      reference_number: '參考編號',
      type: '通行證',
      status: '狀態',
      valid_until: '有效期至',
      account: '用戶',
      checkin_time: '登記進入',
      checkout_time: '登記離開',
      purchase_preview: '健身室通行證詳情',
      confirm_msg: '你已成功購買健身室通行證',
      confirm_day_pass_msg: '在購買一次性健身房通行證之前，請檢查健身房是否可用。',
    },
    point_transaction: {
      create_at: '日期',
      type: '',
      amount: '積分',
      top_up_title: '增值',
    },
    package: {
      detail_title: '購買禮包詳情',
      preview: '預覽',
      create_at: '購買日期',
      name: '禮包名稱',
      description: '詳情',
      content: '禮包內容',
      price: '價格',
      no_package: '沒有購買紀錄',

      order_expired_msg: '預訂已被取消，請重新預訂',
    },
    invoice: {
      download_pdf: '下載發票PDF',
      download_receipt: '下載收據PDF',
      pay: '付款',
      pay_title: '付款',
      pay_success_title: '付款成功',
      summary: '發票詳情',
      payment_reference_no: '付款參考編號',
      upload_success: '上傳成功',
    },

    //Admin
    admin: {
      sasv: 'SASV',
      member: '用戶',
      operator: '管理員',
      hkiarace: '機場同業綜藝社',
      acc_booking: 'Clubhouse',
      settings: '設置',
    },
    admin_login: {
      title: '管理員登入',
      username: '用戶名稱',
    },

    admin_sasv: {
      title: 'SASV',
      edit_title: 'SASV 詳情',
      duplicate_title: '重複登記姓名',
      validate_title: '認證 SASV',

      update_at: '最後更新日期',
      octopus_no: '八達通號碼',
      name: '全名',
      surname: '姓氏',
      given_name: '名字',
      id_type: '證明文件類別',
      id: '身份證明文件',
      company: '公司',
      other_company_name: '其他公司名稱',
      create_new_company: '新增公司',
      new_company_name_en: '公司名稱 (英文)',
      new_company_name_zh: '公司名稱 (中文)',
      validated_at: '認證日期',
      rejected_at: '拒絕日期',
      reject_reason: '拒絕原因',
      status: '狀態',

      octopus_front: '八達通卡 (正面)',
      octopus_back: '八達通卡 (背面)',
      staff_card_front: '公司員工證 (正面)',
      staff_card_back: '公司員工證 (背面)',

      accept: '通過',
      confirm_accept_msg: '確認通過?',
      reject: '拒絕',
      confirm_reject_msg: '確認拒絕?',
      suspend: '停用',
      suspend_confirm_msg: '確認停用?',
      unsuspend: '啟用',
      unsuspend_confirm_msg: '確認啟用?',

      mass_suspend_title: '批量停用',
      mass_suspend_csv: '上傳 CSV',

      email_templates: '電郵模版',

      source: '註冊途徑',
    },

    admin_user: {
      title: '用戶',
      add_user: '新增用戶',
      user_detail: '用戶資料',
      id_front: '證件前方',
      id_back: '證件後方',
      jwt: 'HKIARaCE卡二維碼',
      serial_no: 'HKIARaCE卡編號',
      name_en: '名稱（英文）',
      name_zh: '名稱（中文）',
      sasv_name: '機場員工八達通卡上的姓名',
      company: '公司',
      email: '電郵',
      id_type: '證件種類',
      id_no: '八達通號碼',
      id_expiry_date: '證件到期日',
      accept: '通過',
      accept_with_gift: '通過 (未領取迎新禮物)',
      accept_without_gift: '通過 (已領取迎新禮物)',
      reject: '不通過',
      email_verified_at: '電郵認證於',
      id_verified_at: '證件認證於',
      last_login: '最後登入',
      locked_until: '帳號已鎖',
      id_verification_status: '證件認證狀態',
      sasv_not_submitted: '未提交SASV',
      acc_suspend_until: '會籍停用至',
      welcome_gift_redeemed: '領取迎新禮物日期',
      is_trial_user: '試用用戶',
      remarks: '備註',

      require_email_verification: '需要用戶認證電郵',
      require_id_verification: '需要用戶認證證件',

      validate_id_title: '證件認證',

      confirm_accept_msg: '確認通過證件認證？',
      confirm_reject_msg: '確認不通過證件認證？',
      confirm_unlock_msg: '確認解鎖帳號?',
      confirm_enable_msg: '確認啟用帳號?',
      confirm_disable_msg: '確認停用帳號?',
      confirm_remove_suspension_msg: '確認啟用帳號?',

      add_point_title: '增加積分',
      add_point_success_msg: '成功增加積分',
      add_gym_pass_title: '新增健身室通行證',
      add_gym_pass_success_msg: '成功新增健身室通行證',

      enrollment_history: '報名紀錄',
      attendance_history: '參與紀錄',
      booking_history: '設施預訂紀錄',
      payment_history: '付款紀錄',
      coupon: '使用證',

      export_user: '匯出',
    },

    admin_operator: {
      title: '管理員',
      add_operator: '新增管理員',
      operator_detail: '管理員資料',
      email: '電郵',
      name_en: '名稱（英文）',
      name_zh: '名稱（中文）',
      disabled: '停用',
      locked_until: '帳號已鎖',
      managed_events: '管理活動',
      user_type: '用戶類別',
      permissions: '管理權限',
      permission_pre_sets: '權限模版',
      permission_pre_set_hkiarace_admin: 'HKIARaCE主管',
      permission_pre_set_acc_admin: 'ASC主管',
      permission_pre_set_helper: '活動助手',
    },

    admin_hkiarace: {
      company: '公司',
      add_company: '新增公司',
      user: '用戶',
      operator: '管理員',
      event_category: '活動類別',
      event: '活動',
      promotion: '員工優惠',
      corporate_vendor: 'Corporate Vendors',
      email_template: '電郵模版',
      home_page: '主頁',
      check_in: '簽到',
      report: '報告',
    },
    admin_company: {
      add_company: '新增公司',
      edit_company: '修改公司',
      name_en: '公司名稱（英文）',
      name_zh: '公司名稱（中文）',
      disabled: '停用',
    },
    admin_event_category: {
      title: '活動類型',
      add_category: '新增活動類型',
      edit_category: '活動類型',
      name_en: '名稱（英文）',
      name_zh: '名稱（中文）',
      color: '顔色',
      layout_style: '表示形式',
      layout_style_list: '列表',
      layout_style_grid: '走馬燈',
      confirm_delete_category: '確認刪除活動類型？',
    },
    admin_event: {
      add_title: '新建活動',
      edit_title: '活動詳情',
      name_en: '名稱（英文）',
      name_zh: '名稱（中文）',
      order_no: '排列次序',
      signup_mode: '活動類型',
      date: '日期',
      time: '時間',
      start_time: '開始時間',
      end_time: '結束時間',
      fee: '費用',
      fixed_fee: '固定價錢',
      fee_with_tiers: '分級收費',
      fee_tier: '分級',
      fee_tier_en: '分級（英文）',
      fee_tier_zh: '分級（中文）',
      fee_tier_max: '最多人數',
      add_fee_tier: '新增分級',
      quota: '配額',
      location_en: '地點（英文）',
      location_zh: '地點（中文）',
      languages: '語言',
      remarks_en: '備註（英文）',
      remarks_zh: '備註（中文）',
      visible_from: '發怖日期',
      signup_until: '截止報名日期',
      visible_until: '隱藏日期',
      visible_forever: '永不隱藏',
      banner: '橫額',
      description_en: '橫額描述（英文）',
      description_zh: '橫額描述（中文）',
      poster: '海報',
      attachment: '附件',
      images: '圖片',
      category: '分類',
      survey: '問卷調查',
      no_session_msg: '尚未為此活動設置場次',
      confirm_no_session_msg: '你尚未為此活動設置場次，你確認你要設置發怖日期？',

      invalid_form_msg: '請檢查已輸入資料',
      save_success_msg: '已儲存',
    },
    admin_series: {
      title: '活動系列',
      add_title: '新增系列',
      detail_title: '系列詳情',
      sessions: '包含場次',
      no_session_msg: '請最少選擇一個場次',
    },
    admin_event_survey: {
      survey_enabled: '顯示問卷',
      title_en: '問卷標題（英文）',
      title_zh: '問卷標題（中文）',
      description_en: '問卷簡介（英文）',
      description_zh: '問卷簡介（中文）',
      questions: '問題',
      add_single_line_question: '新增短問題',
      add_freetext_question: '新增文字問題',
      add_rating_question: '新增評分問題',
      clone_question: '複制問題',
      delete_question: '移除問題',
      question_type: '問題類型',
      question_title_en: '問題題目（英文）',
      question_title_zh: '問題題目（中文）',
      question_max_label_en: '5分標示（英文）',
      question_max_label_zh: '5分標示（中文）',
      question_min_label_en: '1分標示（英文）',
      question_min_label_zh: '1分標示（中文）',
      question_required: '必填',
      user_input: '答案',
      freetext: '文字問題',
      rating: '評分問題',
      export_data: '導出',
      save_success_msg: '已成功儲存問卷',
    },
    admin_session: {
      title: '場次',
      add_title: '增加場次',
      edit_title: '場次詳情',
      name_en: '名稱（英文）',
      name_zh: '名稱（中文）',
      time: '場次時間',
      start: '開始時間',
      end: '完結時間',
      quota: '名額',
      delete_msg: '確認刪除場次？',
    },
    admin_enrollment: {
      enrolled_at: '報名時間',
      account: '用戶',
      company: '公司',
      last_enrollment: '最後一次報名',
      pending: '未決定',
      accept: '報名成功',
      reject: '報名失敗',
      accepted: '成功',
      rejected: '失敗',
      event: '活動',
      session: '場次',
      series: '系列',
      meta: '報名人數',
      status: '狀態',
      email_status: '電郵狀態',
      send_email: '發送電郵',
      select_template: '選擇模版',
      send: '發送',
    },
    admin_participant: {
      title: '參與紀錄',
      select_template: '選擇模板',
      send_email: '發送活動確認電郵',
      send_survey_email: '發送活動問卷電郵',
      send: '發送',
      event: '活動',
      session: '場次',
      account: '用戶',
      company: '公司',
      mark_paid: '已付款',
      checkin_time: '簽到時間',
      manual_check_in: '手動簽到',
      mark_paid_confirm_msg: '確認標記已收款？',
      mark_paid_success_msg: '已標記已收款',
      unmark_paid_confirm_msg: '確認撤銷收款記錄？',
      unmark_paid_success_msg: '收款記錄已撤銷',
      refund_success_msg: '退款成功',
      check_in_confirm_msg: '確認手動簽到？',
      check_in_success_msg: '手動簽到成功',
      cancel_check_in: '取消簽到',
      cancel_check_in_confirm_msg: '確認取消簽到？',
      cancel_check_in_success_msg: '取消簽到成功',

      normal_email: 'Normal Email',
      confirmation_email: 'Normal Email',
      survey_email: 'Normal Email',
    },
    admin_payment: {
      title: '付款紀錄',
      total: '總金額',
      create_at: '下單時間',
      ref_no: '參考編號',
      card_no: '信用卡號碼',
      account: '用戶',
      payment_type: '付款種類',
      payment_method: '付款方式',
      refunded: '已退款',
    },
    admin_memorable_moment: {
      memorable_moment_enabled: '顯示於精彩時刻',
      enable: '顯示',
      disable: '隱藏',
      enabled: '顯示',
      disabled: '隱藏',
      revert: '復原',
      cover: '封面相片',
      add_photo: '新增相片',
      photo: '相片',
      reorder: '排序',
    },
    admin_promotion: {
      title: '員工優惠',
      add_title: '新增員工優惠',
      edit_title: '員工優惠詳情',
      name: '名稱',
      from_time: '顯示日期',
      to_time: '隱藏日期',
      icon: '圖示',
      content: '內容',
      publish_promotion: '發送電郵',
      confirm_publish_msg: '確認發送電郵予全體用戶？',
    },
    admin_corporate_vendor: {
      title: 'Corporate Vendor',
      add_title: '新增 Corporate Vendor',
      edit_title: 'Corporate Vendor 詳情',
      name_en: '名稱 (英文)',
      name_zh: '名稱 (中文)',
      from_time: '顯示日期',
      to_time: '隱藏日期',
      icon_en: '圖示 (英文)',
      icon_zh: '圖示 (中文)',
      url_en: 'Redirect URL (英文)',
      url_zh: 'Redirect URL (中文)',
      popup_enabled: '彈出視窗',
      content_en: '彈出視窗內容(英文)',
      content_zh: '彈出視窗內容(中文)',
    },
    admin_notification_template: {
      edit_title: '更改電郵模版',

      type: '電郵類型',
      name: '模版名稱',
      email_enabled: '啟用電郵',
      email_subject: '電郵標題',
      email_content: '電郵內容',
      push_notification_enabled: '啟用推送',
      push_notification_content: '推送內容',
      test_email: '測試電郵',
      recipient: '接收電郵地址',
      send_email: '發送',
      new_template: '新建模版',
      delete_template: '刪除模版',
      confirm_send_email: '確認發送電郵？',
      email_sent: '電郵已發送',
    },
    admin_survey: {
      title: '問卷',
      add_title: '新增問卷',
      detail_title: '問卷詳情',
      survey_link: '問卷鏈結',
      title_en: '問卷標題（英文）',
      title_zh: '問卷標題（中文）',
      start: '問卷開始時間',
      end: '問卷結束時間',
      require_login: '要求用戶登入',
      description_en: '問卷簡介（英文）',
      description_zh: '問卷簡介（中文）',
      questions: '問題',
      response_count: '回覆數量',
      add_single_line_question: '新增短問題',
      add_freetext_question: '新增長問題',
      add_rating_question: '新增評分問題',
      question_type: '問題類型',
      question_title_en: '問題題目（英文）',
      question_title_zh: '問題題目（中文）',
      question_max_label_en: '5分標示（英文）',
      question_max_label_zh: '5分標示（中文）',
      question_min_label_en: '1分標示（英文）',
      question_min_label_zh: '1分標示（中文）',
      question_required: '必填',
      user_input: '答案',
      single_line: '短問題',
      freetext: '長問題',
      rating: '評分問題',
      delete_msg: '確認刪除問卷？',
      save_success_msg: '已儲存問卷',
      publish_survey: '發送電郵',
      confirm_publish_msg: '確認發送電郵予全體用戶？',
    },
    admin_home_page: {
      title: '主頁設置',
      top_carousel: '頂部走馬燈顯示之活動',
      category_event: '各類別封面活動',
      leisure_event: '興趣班',
      seminar_event: '講座',
      mega_event: '大型活動',
      memorable_moment: '精彩時刻',
      upcoming_events: '近期活動',
      banner: '彈出橫額',

      maintenance_mode: '維修模式',
      maintenance_status: '現時狀態',
      maintenance_enabled: '已於{create_at}啟用',
      maintenance_disabled: '已停用',
      start_maintenance: '啟用維修模式',
      end_maintenance: '停用維修模式',
      confirm_start_maintenance_msg: '確認啟用維修模式？',
      confirm_end_maintenance_msg: '確認停用維修模式',
    },
    admin_check_in: {
      title: '簽到',
      event: '活動',
      select_event: '選擇活動',
      session: '場次',
      select_session: '選擇場次',
      scan_qr_code: '掃描二維碼',
      invalid_token: '二維碼無效',
      token_expired: '二維碼已過期',
      confirm_msg: '確認簽到？',
      no_record: '沒有記錄',
    },
    admin_redeem_welcome_gift: {
      title: '領取迎新禮物',

      hkiarace_card_no: 'HKIARaCE卡編號',
    },
    admin_report: {
      title: '報告',
      registered_user: '登記人數',
      event_total_hour: '類別總活動時數',
      category_application: '參與人數',
      event_attendance: '出席數據',
      application_company: '報名公司數量',
      application_user: '報名人數',
      application_aa_user: '機管局報名人數',
      application_non_aa_user: '非機管局報名人數',
      participant_company: '參與公司數量',
      participant_aa_user: '機管局參與人數',
      participant_non_aa_user: '非機管局參與人數',
      participant_user: '參與人數',
      attendance_user: '出席人數',
      interval_month: '每月',
      interval_year: '每年',
      special_offer_count: '員工特別優惠數量',
      special_offer_view_count: '員工特別優惠顯示次數',
      corporate_vendor_view_count: 'Corporate Vendor顯示次數',
      show_report: '顯示',

      acc_booking_report: '設施預訂報告',
      confirmed: '已確認預訂',
      cancelled_by_user: '已取消預訂',
      cancelled_by_admin: '已被取消預訂',
      refunded: '已退款預訂',
      no_show: '未出席預訂',

      acc_payment_report: '收費報告',
      octopus_count: '八達通筆數',
      octopus_amount: '八達通金額',
      cyber_source_count: 'Visa / Master / Jetco 筆數',
      cyber_source_amount: 'Visa / Master / Jetco 金額',
      union_pay_count: '銀聯信用卡筆數',
      union_pay_amount: '銀聯信用卡金額',
      coupon_count: '代用券筆數',
      coupon_amount: '代用券金額',

      no_grouping: '總數',
      all_categories: '全部 (以類別區分)',
      all_events: '全部 (以活動區分)',
      all_regions: '全部 (以區域區分)',
      all_facility_types: '全部 (以設施類別區分)',

      acc_income_report: 'Monthly Income Report',
      daily_acc_usage_report: 'Daily Facility Utilisation Report',
      monthly_acc_usage_report: 'Monthly Facility Utilisation Report',
      report_recipients: 'Report Recipients',
    },
    admin_tnc: {
      title: '條款及細則',
      title_en: '標題 (英文)',
      content_en: '內容 (英文)',
      title_zh: '標題 (中文)',
      content_zh: '內容 (中文)',
      privacy_title_en: '私隱政策標題 (英文)',
      privacy_content_en: '私隱政策內容 (英文)',
      privacy_title_zh: '私隱政策標題 (中文)',
      privacy_content_zh: '私隱政策內容 (中文)',
    },
    admin_banner: {
      add_title: '新增彈出橫額',
      edit_title: '修改橫額',
      name: '名稱',
      require_login: '顯示予已登入用戶',
      path: '顯示頁面網址',
      from_time: '顯示日期',
      to_time: '隱藏日期',
      banner_en: '彈出橫額(英文)',
      banner_zh: '彈出橫額(中文)',
      link_en: 'URL (英文)',
      link_zh: 'URL (中文)',
      with_content: '文字內容',
      content_en: '文字內容(英文)',
      content_zh: '文字內容(中文)',
    },

    admin_acc: {
      dashboard: '儀表板',
      booking: '預訂',
      recurrent_booking: '重複預訂',
      purchase_order: '訂單',
      invoice: '發票',
      member: '用戶',
      facility: '設施',
      gym: '健身室',
      package: '優惠禮包',
      discount_code: '優惠碼',
      coupon: '使用證',
      region: '區域',
      email_templates: '電郵模版',
    },
    admin_acc_booking: {
      title: '預訂',
      export: '導出',
      add: '新增預約',
      reference_number: '參考編號',
      payment_reference_number: '付款參考編號',
      reserved_at: '預約時間',
      datetime: '預訂時間',
      date: '日期',
      time: '時間',
      start_time: '開始時間',
      end_time: '結束時間',
      facility: '設施',
      checkin_time: '簽到時間',
      checkout_time: '退場時間',
      second_contact_number: '備用聯絡電話',
      remarks: '備註',
      status: '預訂狀態',
      not_checked_in: '未簽到',
      checked_in: '已簽到',
      cancel: '取消預訂',
      confirm_cancel_msg: '確認取消預訂？',
      refund: '退款',
      confirm_refund_msg: '確認退款？',
      check_in: '簽到',
      confirm_checkin_msg: '確認簽到？',
      uncheck_in: '取消簽到',
      confirm_uncheckin_msg: '確認取消簽到？',
      cancel_success_msg: '預訂已取消',
      checkin_success_msg: '簽到成功',
      uncheckin_success_msg: '取消簽到成功',
      save_remarks: '儲存備註',
      save_remarks_success_msg: '成功儲存備註',

      check_in_title: '設施簽到',
      check_in_scan_title: '掃描預訂或用戶二維碼',
      check_in_scan_user_title: '掃描用戶二維碼',

      add_additional_item_title: '增加附加項目',
      add_additional_item_confirm_msg: '確認增加附加項目至此預訂？',
      add_additional_item_success_msg: '成功增加附加項目',

      with_purchase_order: '訂單',
    },
    admin_acc_recurrent_booking: {
      edit_title: '重複預訂詳情',

      reserved_at: '預約時間',
      reference_number: '參考編號',
      recurrent_title: '重複預訂標題',
    },
    admin_acc_booking_add: {
      title: '新增預訂',
      facility_type: '設施類別',
      facility: '設施',
      type: '預訂類別',
      user_booking: '用戶預訂',
      maintenance_booking: '維修停用',
      maintenance_title: '維修停用原因',
      date: '預訂日期',
      from_time: '預訂開始時間',
      to_time: '預訂結束時間',
      start_time: '開始時間',
      end_time: '結束時間',
      user: '用戶',
      is_recurring: '重複預訂',
      recur_title: '預訂標題',
      recur_start_date: '重複開始日期',
      recur_end_date: '重複結束日期',
      repeat_every: '重複頻率',
      repeat_interval: '重複間隔',
      recur_until: '重複結束日期',
      repeat_every_day: '天',
      repeat_every_week: '每週',
      repeat_every_month: '每月',
      recur_start_time: '每次開始時間',
      recur_end_time: '每次結束時間',
      recur_replace_booking: '取代現有預訂',
      recur_select_other_option: '選擇其他場地',
      recur_cancel_booking: '取消這次預訂',
      waive_fee: '豁免費用',
      fee: '預訂費用',
      maintenance_from_date: '維修開始日期',
      maintenance_to_date: '維修完成日期',
      remarks: 'OSS',
      booking_cancel_success_msg: '預訂已被成功取消',
      refund_all_warning: '所有受影響預訂將被取消，請確認',
      success_msg: '已儲存維修記錄',
      add_maintenance_booking: '新增維修停用',
      add_user_booking: '新增用戶預訂',
    },
    admin_acc_member: {
      title: '用戶',
    },
    admin_acc_facility_type: {
      title: '設施類別',
      add_title: '新增設施類別',
      edit_title: '設施類別詳情',
      no_item: '未有設施類別',
      name_en: '名稱（英文）',
      name_zh: '名稱（中文）',
      description_en: '描述（英文）',
      description_zh: '描述（中文）',
      open_for_booking: '開放預訂',
      auto_assign_items: '自動分配設施',
      duration: '每節長度（分鐘）',
      fee: '費用',
      per_session: '每節',
      with_quota: '配額制',
      icon: '圖示',
      banner: '橫額',
      photo: '圖片',
      show_congestion_status: '顯示設施擠迫程度',
      confirm_delete_msg: '確認刪除設施類別？',
      save_success_msg: '設施類別已更新',

      price_tiers: '價格級別',
      additional_items: '附加項目',
      day_schedule: '日程設定',
      week_schedule: '日程配置',
      adhoc_week_schedule: '特別日程配置',
      calendar: '月曆表檢閱',
    },
    admin_acc_item_type_additional_item: {
      add_title: '新增附加項目',
      edit_title: '附加項目詳情',

      name_en: '名稱（英文）',
      name_zh: '名稱（中文）',
      price: '費用',
      max_per_booking: '每次預訂最多數量',
      icon: '圖片',
    },
    admin_acc_price_tier: {
      name: '名稱',
      name_en: '名稱 (英文)',
      name_zh: '名稱 (中文)',
      price: '價錢',
      add_title: '增加收費類別',
      edit_title: '修改收費類別',
      confirm_delete: '確認刪除收費類別?',
      legend: '代號',
      legend_en: '代號 (英文)',
      legend_zh: '代號 (中文)',
    },
    admin_acc_day_schedule: {
      name: '名稱',
      add_title: '增加時間表',
      edit_title: '修改時間表',
      select_schedule: '選擇時間表以開始',
      confirm_delete: '確認刪除時間表?',
      add_session_title: '增加時段',
    },
    admin_acc_week_schedule: {
      day_1: '星期一',
      day_2: '星期二',
      day_3: '星期三',
      day_4: '星期四',
      day_5: '星期五',
      day_6: '星期六',
      day_7: '星期日',
      public_holiday_schedule: '公眾假期',
    },
    admin_acc_adhoc_week_schedule: {
      add_title: '增加臨時時間表',
      name: '名稱',
      priority: '優先次序',
      valid_from: '生效日期',
      valid_until: '失效日期',
    },
    admin_acc_gym_subscription_type: {
      title: '健身室通行證類別',
      add_title: '增加健身室通行證類別',
      edit_title: '增加健身室通行證類別',
      name_en: '名稱（英文）',
      name_zh: '名稱（中文）',
      description_en: '簡介（英文）',
      description_zh: '簡介（中文）',
      price: '價錢',
      can_reserve: '可預訂',
      valid_for_uses: '有效次數 (-1: 無限)',
      valid_for_days: '有效日數 (-1: 無限)',
    },
    admin_acc_gym_subscription: {
      title: '健身室通行證',
      check_in_title: '健身室通行證簽到',
    },
    admin_acc_gym_booking: {
      title: '健身室預訂',
    },
    admin_acc_gym_checkin: {
      title: '健身室簽到',
      scan_qr_code: '掃描用戶二維碼',
      has_booking: '預訂 / 即場',
      booking_time: '預訂時間',
      booking: '預訂',
      walkin: '即場',
      walkin_capacity: '即場名額',
      account_pic: '用戶照片',
      scan_white_card: '掃描白卡二維碼',
      success_msg: '白卡編號: A{card_id}, 簽到成功',
    },
    admin_acc_package_page: {
      title: '禮包頁面',

      banner: '橫額',
      header_en: '標題 (英文)',
      header_zh: '標題 (中文)',
      subheader_en: '副標題 (英文)',
      subheader_zh: '副標題 (中文)',
      content_en: '內容 (英文)',
      content_zh: '內容 (中文)',
      footer_en: '註腳 (英文)',
      footer_zh: '註腳 (中文)',
    },
    admin_acc_package_type: {
      title: '優惠禮包',
      add_title: '新增優惠禮包',
      edit_title: '修改優惠禮包',

      link: '禮包連結',
      name_en: '名稱（英文）',
      name_zh: '名稱（中文）',
      banner: '橫額',
      description_en: '描述（英文）',
      description_zh: '描述（中文）',
      price: '價錢',
      content: '禮包內容',
      valid_from: '購買日期',
      valid_until: '截止日期',

      add_content: '新增內容',
      remove_content: '移除內容',
      invalid_valid_until: '請輸入有效截止日期',

      content_type: '內容類別',
      point: '積分數量',
      coupon_item_type: '設施類型',
      coupon_count: '使用證數量',
      coupon_amount: '使用證金額',
      coupon_valid_until: '使用證有效日期',

      delete: '刪除優惠禮包',
      show_package: '購買紀錄',
      confirm_delete_msg: '確認刪除優惠禮包？',
    },
    admin_acc_package: {
      title: '禮包購買紀錄',

      create_at: '購買日期',
      account: 'User',
      type: 'Package Type',
      status: 'Status',
    },
    admin_acc_location: {
      title: '地點',
      add_title: '新增地點',
      edit_title: '地點詳情',
      no_location: '沒有地點',
      name_en: '名稱（英文）',
      name_zh: '名稱（中文）',
      address_en: '地址 (英文)',
      address_zh: '地址 (中文)',
      opening_hours: '開放時間',
      follow_parent_hours: 'Follow Parent Opening / Closing Hours',
      opening_hour: '開放時間',
      closing_hour: '關閉時間',
      confirm_delete_msg: '確認刪除地點？',
      save_success_msg: '地點已更新',
    },
    admin_acc_region: {
      title: '區域',
      add_title: '新增區域',
      edit_title: '區域詳情',
      no_region: '未有區域',
      no_item: '未有區域',
      name_en: '名稱（英文）',
      name_zh: '名稱（中文）',
      location: '地點',
      opening_hours: '開放時間',
      follow_parent_hours: '與上級開放時間相同',
      opening_hour: '開放時間',
      closing_hour: '關閉時間',
      confirm_delete_msg: '確認刪除區域？',
      save_success_msg: '區域已更新',
      exclusion: '設施捆綁',
    },
    admin_acc_item_type: {
      regenerate_sessions: '重新生成',
    },
    admin_acc_item: {
      title: '設施',
      add_title: '新增設施',
      edit_title: '設施詳情',
      no_item: '未有設施',
      name_en: '名稱（英文）',
      name_zh: '名稱（中文）',
      location: '地點',
      region: '區域',
      item_type: '設施類別',
      opening_hours: '開放時間',
      follow_parent_hours: '與上級開放時間相同',
      opening_hour: '開放時間',
      closing_hour: '關閉時間',
      confirm_delete_msg: '確認刪除設施？',
      save_success_msg: '設施已更新',
    },
    admin_acc_settings: {
      title: '設置',
      in_advance_booking_period: '預先預訂期限 (日)',
      booking_limit_user: '每位用戶總共最多預訂節數',
      booking_limit_day: '每位用戶每日最多預訂節數',
      booking_limit_month: '每位用戶每月最多預訂時數 (小時)',
      no_show_penalty_limit: '最多無出席次數',
      no_show_penalty_period: '無出席次數計算時間 (日)',
      no_show_penalty_suspension_period: '因無出席次數過多停用期間 (日)',
      booking_reminder: '提醒電郵發出時間 (日前)',
      coupon_expiry_period: '使用證有效限期 (日)',
      acc_membership_price: '付費用戶升級費用（港幣）',
      acc_membership_period: '付費用戶升級期限（日）',
      hkiarace_membership_renew_reminder: 'HKIARaCE證件認證提醒電郵發出時間 (日前)',
      acc_point_top_up_options: 'Loyalty Points Top Up Tiers',
      top_up_tier_price: 'Price',
      top_up_tier_amount: 'Loyalty Points',
      add_top_up_tier: 'Add Tier',
      acc_point_exchange_rate: 'Point Exchange Rate',
      acc_max_gym_reservation: '健身室預訂限額',
      acc_max_gym_capacity: '健身室總容量（預訂+即場）',

      confirm_save_msg: '確認儲存？',
      settings_saved: '預訂規則已儲存',
    },
    admin_acc_email_template: {
      title: '電郵模版',
    },
    admin_acc_public_holiday: {
      title: '公眾假期',
      add_title: '新增公眾假期',
      edit_title: '修改公眾假期',
      name: '名稱',
      date: '日期',
    },
    admin_acc_white_card: {
      title: '白卡管理',
      detail_title: '白卡使用紀錄',
      add: '新增白卡',
      add_confirm_msg: '確認新增白卡？',
      export: '下載二維碼',
      deactivate: '停用',
      deactivate_confirm_msg: '確認停用白卡？',
      reactivate: '啟用',
      reactivate_confirm_msg: '確認啟用白卡？',

      id: '編號',
      active: '啟用',
      user: '用戶',

      check_out_title: '退場',
      scan_qr_code: '掃描白卡二維碼',
      not_check_in: '未有使用紀錄',
      bookings: '設施預訂',
      gym_check_ins: '健身室簽到紀錄',
      check_out_confirm_msg: '確認退場？',
      check_out_success_msg: '退場成功',
    },
    admin_acc_check_in: {
      title: '設施簽到',
      bookings: '預訂',
      white_cards: '白卡',
      confirm_msg: '以{white_card_count}張白卡簽到{booking_count}個預訂?',
    },
    admin_acc_purchase_order: {
      add_title: '新增訂單',
      edit_title: '訂單詳情',

      id: '訂單號碼',
      created_by: 'Created By',
      recipient: '客戶',
      recipient_hkiarace_no: '客戶HKIARaCE編號',
      issued_at: '發出日期',
      due_at: '到期日期',
      title: '標題',
      remarks: '備註',
      amount: '總金額',
      paid: '已付金額',
      due: '剩餘金額',
      status: '狀態',

      bookings: '預訂',
      remove_bookings: '移除',
      add_bookings: '選擇預訂',
      add_recurrent_bookings: '選擇重複預訂',

      delete_confirm_msg: '刪除訂單?',

      invoices: '發票',

    },
    admin_acc_invoice: {
      add_title: '新增發票',
      edit_title: '發票詳情',

      invoice_no: '發票編號',
      issued_at: '發出日期',
      due_at: '到期日期',
      title: '標題',
      details: '內容',
      amount: '金額',
      status: '狀態',
      remarks: '備註',
      save_remarks: '儲存備註',

      item: '項目',
      unit_price: '單價',
      quantity: '數量',
      subtotal: '小計',
      discount_percentage: '折扣 %',
      discount_amount: '折扣金額',
      total: '總數',

      payment: '付款',

      delete_confirm_msg: '刪除發票?',

      send: '寄出',
      send_confirm_msg: '寄出發票予客戶?',
      send_success_msg: '成功寄出',

      payment_method: '付款方式',
      payment_proof: '付款證明',

      approve: '確認',
      approve_confirm_msg: '確認款項已收妥?',

      setting_title: '發票',
      invoice_pdf_footer: '發票PDF註腳',
      invoice_bank_transfer_payment_instructions: '發票付款指示 - 銀行轉賬',
      invoice_cheque_payment_instructions: '發票付款指示 - 支票',
      receipt_pdf_footer: '收據PDF註腳',
    },
    admin_acc_discount_code: {
      code: '優惠碼',
      start: '開始日期',
      end: '完結日期',
      type: '類別',
      type_FACILITY: '設施預訂',
      type_GYM_PASS: '健身室通行證',
      type_MEMBERSHIP: '會籍',
      item_type: '設施類別',
      gym_pass_type: '健身室通行證類別',
      minimum_amount: '最低金額',
      discount: '折扣',
      discount_value: '折扣金額',
      discount_percentage: '折扣百分比',
      change_discount_type: '變更',
      quota: '整體使用次數',
      use_per_account: '每個用戶使用次數',
      infinite: '無限次',

      add_title: '新增優惠碼',
      edit_title: '優惠碼詳情',
      list_records: '使用記錄',
      list_record_title: '優惠碼使用記錄',

      delete_confirm_msg: '確認刪除？',
    },
    admin_acc_discount_code_record: {
      created_at: '日期',
    },
    admin_acc_coupon: {
      account: '',
      valid_until: '過期日期',
      amount: '折扣金額',
      redeem_code: '換領碼',
      redeemed: '已換領',
      redeemed_at: '換領日期',
      quantity: '數量',

      type: '類別',
      type_FACILITY: '設施預訂',
      type_GYM_PASS: '健身室通行證',
      type_MEMBERSHIP: '會籍',

      edit_title: '更改使用證過期日期',
    },
    admin_acc_coupon_group: {
      add_title: '新增使用證群組',
      edit_title: '使用證群組詳情',
      add_coupon_title: '新增使用證',
      assign_title: '指派使用證',
      assign_user: '指派使用證予用戶',

      name: '名稱',

      delete_confirm_msg: '刪除使用證群組?',
    },

    notification_record: {
      title: '通知紀錄',
      create_at: '通知日期',
      template: '模版',
      type: '類型',
      email: '電郵',
      push_notification: '推送通知',
      toggle_email_details: '顯示/隱藏電郵詳情',
      email_subject: '標題',
      email_content: '內容',
    },

    jwt_scanner: {
      scanner_hint: '以掃碼器掃描',
      or: '或',
      webcam_label: '以鏡頭掃描',
      manual_input_hint: '手動輸入後按ENTER',
    },
    camera_capture: {
      fallback: '上傳',
      capture: '拍攝',
    },
    // Constants
    languages: {
      en: '英語',
      'zh-Hant': '廣東話',
      'zh-Hans': '普通話',
    },
    event_signup_mode: {
      disabled: "不接受報名",
      single_session: "單次活動",
      multi_session: "多場次活動",
      multi_series: "多系列活動",
    },
    email_template_types: {
      registration_ack: '登記完成',
      email_verification: '郵箱驗證',
      new_device_otp: '新登入OTP',
      reset_password: '重置密碼',
      id_verification_ack: '證件提交完成',
      id_verification_success: '證件驗證成功',
      id_verification_success_with_gift: '證件驗證成功 (未領取迎新禮物)',
      id_verification_fail: '證件驗證失敗',
      id_verification_remind: '證件驗證即將到期',
      event_enrollment_ack: '報名確認',
      event_payment_confirmation: '付款成功',
      old_member_invite: '舊有用戶邀請函',

      booking_confirmation: '預訂成功',
      booking_reminder: '預訂提醒',
      booking_cancellation: '預訂取消',
      member_suspension: '用戶被停用',
      bbq_option_admin: 'BBQ Option (User)',
      bbq_option_user: 'BBQ Option (Admin)',
      gym_pass_confirmation: '健身室通行證確認',
      package_confirmation: '禮包確認',
      membership_confirmation: 'Membership Confirmation',
      point_top_up: 'Loyalty Point Confirmation',
      invoice_sent: 'Purchase Order Invoice',
      invoice_receipt: 'Invoice Receipt',

      REGISTRATION_APPROVED: 'Registration Approved',
      REGISTRATION_REJECTED: 'Registration Rejected',
      PENDING_APPROVAL: 'Pending Manual Approval',
      REGISTRATION_SUSPENDED: 'Registration Suspended',
    },
    event_status: {
      enrolled: '已報名',
      enrollment_ended: '已截止報名',
      ended: '已截止報名',
    },
    salutation: {
      mr: '先生',
      mrs: '太太',
      ms: '小姐',
      dr: '博士',
    },
    id_type: {
      ara_permit: '機場禁區證',
      airport_octopus: '機場八達通卡',
      company_card: '公司員工證',
      personal_octopus: '個人八達通卡 + 公司員工證 / 機場禁區證',
      AIRPORT_OCTOPUS: '機場八達通卡',
      PERSONAL_OCTOPUS_AND_STAFF_CARD: '個人八達通卡 + 公司員工證',
      VIP: '貴賓',
    },
    id_verification_status: {
      not_verified: '未認證',
      pending_verification: '等待認證',
      verified: '已認證',
      expired: '已過期',
    },
    sasv_status: {
      NOT_SUBMITTED: '未提交',
      PENDING_APPROVAL: '等待確認',
      APPROVED: '已通過驗證',
      REJECTED: '已拒絕',
      SUSPENDED: '已停用',
    },
    sasv_source: {
      CANTEEN_REGISTRATION: 'STAFF CANTEEN',
      HKIASC: 'HKIA SC',
      ACA_APP: 'ACA',
      null: 'N/A',
    },
    enrollment_status: {
      pending: '已報名，等待確認',
      accepted: '報名成功',
      rejected: '報名未能成功',
      pending_payment: '等待付款',
    },
    account_type: {
      operator: '助理',
      admin: '主管',
    },
    booking_record_status: {
      pending: '等候付款',
      paying: '等候付款',
      confirmed: '已確認',
      cancelled_by_user: '已取消',
      cancelled_by_admin: '已被取消',
      expired: '已過期',
      no_show: '未有出席',
    },
    booking_status: {
      available: '未預訂',
      excluded: '被其他設施佔用',
      reserved: '已預留',
      confirmed: '已確認',
      paying: '等候付款',
      cancelled_by_user: '已取消',
      refunded: '已退款',
      cancelled_by_admin: '已被取消',
      expired: '已過期',
      no_show: '未有出席',
      waiting_for_check_in: '等待簽到',
      checked_in: '已簽到',
      created_by_admin: '管理員預訂',
      create_admin_booking: '新增預訂',
    },
    facility_congestion_status: {
      title: '現時擠迫程度: ',
      0: '低',
      1: '中',
      2: '高',
    },
    payment_method: {
      cyber_source: 'Visa / Master / JCB',
      union_pay: '銀聯卡',

      bank_transfer: '銀行轉賬',
      cheque: '支票',
    },
    payment_type: {
      acc_facility_booking: '設施預訂',
      acc_membership_extend: '會籍',
      event_enrollment: '參加活動',
      invoice: '發票',
    },
    cyber_source_payment_decision: {
      PENDING: '處理中',
      ACCEPT: '已接受',
      DECLINE: '已拒絕',
      REFUND: '已退款',
      NOT_FOUND: '已取消',
      ERROR: '錯誤',
    },
    point_transaction_type: {
      FACILITY_BOOKING: '設施預訂',
      TOP_UP: '增值',
      PACKAGE: '禮包',
    },
    package_content_type: {
      point: '積分',
      coupon: '代用券',
    },
    invoice_status: {
      DRAFT: '草稿',
      SENT: '已寄出',
      AWAITING_PAYMENT: '等待付款',
      PENDING_CONFIRMATION: '等待確認',
      SETTLED: '已付款',
      VOIDED: '已取消',
    },
    discount_code_descriptions: {
      minimum_amount: '超過{amount}元之',
      discount_value: '{discount}元',
      discount_percentage: '{discount}%',
      use_per_account: ' (每位用戶只限使用{count}次)',

      FACILITY: '{minimum_amount}{item_type}預訂減{discount}{use_per_account}',
      GYM_PASS: '購買{gym_pass_type}減{discount}{use_per_account}',
      MEMBERSHIP: '機場員工會所年費減{discount}{use_per_account}',
    },
    error_messages: {
      default: 'Something went wrong. Please try again later',
      duplicate_id_no: '編號已被使用。請與我們聯絡',
      incorrect_code: '認證碼錯誤',
      account_suspended: '你的賬號已被停用',
      id_not_validated: '證件未認證',
      acc_not_activated: 'HKIARaCE會籍未生效。請按下"付款"以升級',
      invalid_booking_id: '無效的預訂編號',
      octopus_not_validated: '請先綁定八達通',
      validate_email: '請先完成電郵認證',
      reuse_password: '最近13次已使用過的密碼不能重用',
      booking_limit_reached: '已超過預訂限額',
      invalid_number_input: '請輸入有效號碼',
      existing_white_card: '用戶已用另一張白卡簽到',
      white_card_in_use: '白卡正在被另一用戶使用',
      invalid_white_card_id: '請輸入有效白卡編號',
      session_taken: '已選項目當前無法預訂，請選擇其他時間或稍後重試',

      invalid_discount_code: '優惠碼無效',
      discount_code_quota_full: '優惠碼使用名額已滿',
      discount_code_user_quota_full: '您已超過優惠碼之使用次數',
      discount_code_minimum_not_met: '未滿足使用優惠碼使用條件',
      discount_code_not_applicable: '優惠碼不適用',
      invalid_coupon_redeem_code: '換領碼無效或過期',
    },

    add: '新增',
    and: '及',
    search: '搜尋',
    all: '全部',
    cancel: '取消',
    next: '下一步',
    reset: '重設',
    finish: '完成',
    disable: '停用',
    enable: '啟用',
    delete: '刪除',
    save: '儲存',
    browse: '瀏覽',
    detail: '詳情',
    minutes: '分鐘',
    checkin: '簽到',
    uncheckin: '取消簽到',
    close: '關閉',
    back: '返回',
    upload: '上傳',
    continue: '繼續',
    not_uploaded: '未上傳',
    not_verified: '未認證',
    unlimited: '無限',
    edit: '編輯',
    login_msg: '請先登入',
    logout_msg: '確認登出？',
    submit: '遞交',
    error_msg: '發生錯誤，請稍後再試',
    export: '導出',
    octopus_not_mapped: '請先綁定八達通',
    yes: '是',
    no: '否',
    name: '{surname}{given_name}',
    date_range: '日期',
    filter: '篩選',
    clear: '清除',
    apply: '套用',
    delete_image_confirm_msg: '刪除圖片?',
    copy: '複制',
    interval_noon: '正午12時',
    interval_format: '{am_pm}{hour}時',
    interval_am: '上午',
    interval_pm: '下午',
    pay: '付款',
    ok: '確定',
  },
};

const i18n = new VueI18n({
  locale: 'en',
  messages,
});

export default i18n;
